/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
import * as $protobuf from "protobufjs/light";

const $root = ($protobuf.roots.split || ($protobuf.roots.split = new $protobuf.Root()))
.addJSON({
  proto_v2: {
    options: {
      go_package: "./proto_v2"
    },
    nested: {
      TsAdminExchangePOrderListRequest: {
        fields: {
          pageSize: {
            type: "int32",
            id: 1
          },
          pageNum: {
            type: "int32",
            id: 2
          },
          pOrderNo: {
            type: "string",
            id: 3
          },
          pMatchNo: {
            type: "string",
            id: 4
          },
          status: {
            type: "PExchangeOrderStatus",
            id: 5
          },
          remark: {
            type: "string",
            id: 6
          },
          startTime: {
            type: "string",
            id: 7
          },
          endTime: {
            type: "string",
            id: 8
          }
        }
      },
      TsAdminExchangePOrderListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          orderList: {
            rule: "repeated",
            type: "Item",
            id: 3
          },
          total: {
            type: "int32",
            id: 4
          }
        },
        nested: {
          Item: {
            fields: {
              pOrderNo: {
                type: "string",
                id: 1
              },
              pMatchNo: {
                type: "string",
                id: 2
              },
              cOrderNum: {
                type: "int32",
                id: 3
              },
              remark: {
                type: "string",
                id: 4
              },
              status: {
                type: "PExchangeOrderStatus",
                id: 5
              },
              orderTime: {
                type: "string",
                id: 6
              },
              statusName: {
                type: "string",
                id: 7
              }
            }
          }
        }
      },
      TsAdminExchangePOrderDetailRequest: {
        fields: {
          pOrderNo: {
            type: "string",
            id: 1
          }
        }
      },
      TsAdminExchangePOrderDetailResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          pOrderNo: {
            type: "string",
            id: 3
          },
          status: {
            type: "PExchangeOrderStatus",
            id: 4
          },
          remark: {
            type: "string",
            id: 5
          }
        }
      },
      TsAdminExchangePOrderRemarkRequest: {
        fields: {
          pOrderNo: {
            type: "string",
            id: 1
          },
          remark: {
            type: "string",
            id: 2
          }
        }
      },
      TsAdminExchangePOrderRemarkResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TsAdminExchangeCOrderListRequest: {
        fields: {
          pMatchNo: {
            type: "string",
            id: 1
          },
          cOrderNo: {
            type: "string",
            id: 2
          },
          userAttr: {
            type: "AdminMatchOrderAttrEnum",
            id: 3
          },
          phoneNum: {
            type: "string",
            id: 4
          },
          pid: {
            type: "string",
            id: 5
          },
          status: {
            type: "CExchangeOrderStatus",
            id: 6
          },
          remark: {
            type: "string",
            id: 7
          },
          startTime: {
            type: "string",
            id: 8
          },
          endTime: {
            type: "string",
            id: 9
          },
          pageNum: {
            type: "int32",
            id: 10
          },
          pageSize: {
            type: "int32",
            id: 11
          }
        }
      },
      TsAdminExchangeCOrderListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          list: {
            rule: "repeated",
            type: "Item",
            id: 3
          },
          total: {
            type: "int32",
            id: 4
          }
        },
        nested: {
          Item: {
            fields: {
              cOrderNo: {
                type: "string",
                id: 1
              },
              pMatchNo: {
                type: "string",
                id: 2
              },
              userAttr: {
                type: "AdminMatchOrderAttrEnum",
                id: 3
              },
              phoneNum: {
                type: "string",
                id: 4
              },
              pid: {
                type: "string",
                id: 5
              },
              matchPid: {
                type: "string",
                id: 6
              },
              payMoney: {
                type: "int32",
                id: 7
              },
              status: {
                type: "CExchangeOrderStatus",
                id: 8
              },
              remark: {
                type: "string",
                id: 9
              },
              orderTime: {
                type: "string",
                id: 10
              },
              buttonList: {
                rule: "repeated",
                type: "ExchangeButton",
                id: 11
              },
              expressNo: {
                type: "string",
                id: 12
              }
            }
          }
        }
      },
      TsAdminExchangeCOrderDetailRequest: {
        fields: {
          cOrderNo: {
            type: "string",
            id: 1
          }
        }
      },
      TsAdminExchangeCOrderDetailResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          basicInfo: {
            type: "OrderInfo",
            id: 3
          },
          userInfo: {
            type: "PsUserAddress",
            id: 4
          },
          affiliationInfo: {
            type: "PsUserAddress",
            id: 5
          },
          buttonList: {
            rule: "repeated",
            type: "ExchangeButton",
            id: 6
          }
        },
        nested: {
          OrderInfo: {
            fields: {
              cOrderNo: {
                type: "string",
                id: 1
              },
              orderSource: {
                type: "PlatformEnum",
                id: 2
              },
              deliverFee: {
                type: "int32",
                id: 3
              },
              status: {
                type: "CExchangeOrderStatus",
                id: 4
              },
              payType: {
                type: "PaymentType",
                id: 5
              },
              realPay: {
                type: "int32",
                id: 6
              },
              orderTime: {
                type: "string",
                id: 7
              },
              payTime: {
                type: "string",
                id: 8
              },
              handleFee: {
                type: "int32",
                id: 9
              },
              diffPrice: {
                type: "int32",
                id: 10
              },
              sellerDeliverTime: {
                type: "string",
                id: 11
              },
              platformDeliverTime: {
                type: "string",
                id: 12
              },
              sellerExpressNo: {
                type: "string",
                id: 13
              },
              platformExpressNo: {
                type: "string",
                id: 14
              },
              platformReceiveTime: {
                type: "string",
                id: 15
              },
              buyerReceiveTime: {
                type: "string",
                id: 16
              },
              remark: {
                type: "string",
                id: 17
              },
              statusName: {
                type: "string",
                id: 18
              }
            }
          }
        }
      },
      TsAdminExchangeCOrderRemarkRequest: {
        fields: {
          cOrderNo: {
            type: "string",
            id: 1
          },
          remark: {
            type: "string",
            id: 2
          }
        }
      },
      TsAdminExchangeCOrderRemarkResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TsAdminExchangeCOrderCancelRequest: {
        fields: {
          cOrderNo: {
            type: "string",
            id: 1
          }
        }
      },
      TsAdminExchangeCOrderCancelResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TsAdminExchangeCOrderConfirmItemRequest: {
        fields: {
          cOrderNo: {
            type: "string",
            id: 1
          }
        }
      },
      TsAdminExchangeCOrderConfirmResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TsAdminExchangeCOrderCheckRequest: {
        fields: {
          cOrderNo: {
            type: "string",
            id: 1
          },
          checkFailed: {
            type: "bool",
            id: 2
          }
        }
      },
      TsAdminExchangeCOrderCheckResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TsAdminExchangeCOrderDeliverRequest: {
        fields: {
          cOrderNo: {
            type: "string",
            id: 1
          },
          expressNo: {
            type: "string",
            id: 2
          }
        }
      },
      TsAdminExchangeCOrderDeliverResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TsAdminExchangeCOrderSendBackRequest: {
        fields: {
          cOrderNo: {
            type: "string",
            id: 1
          },
          expressNo: {
            type: "string",
            id: 2
          }
        }
      },
      TsAdminExchangeCOrderSendBackResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TsAdminExchangeCOrderInfoRequest: {
        fields: {
          cOrderNo: {
            type: "string",
            id: 1
          }
        }
      },
      TsAdminExchangeCOrderInfoResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          esoNo: {
            type: "string",
            id: 3
          },
          eoNo: {
            type: "string",
            id: 4
          },
          moNo: {
            type: "string",
            id: 5
          },
          msoNo: {
            type: "string",
            id: 6
          },
          userExpressNo: {
            type: "string",
            id: 7
          },
          platExpressNo: {
            type: "string",
            id: 8
          },
          addressId: {
            type: "string",
            id: 9
          },
          deliverTime: {
            type: "string",
            id: 10
          },
          platformReceiveTime: {
            type: "string",
            id: 11
          },
          platformDeliverTime: {
            type: "string",
            id: 12
          },
          confirmReceiveTime: {
            type: "string",
            id: 13
          },
          remark: {
            type: "string",
            id: 14
          },
          failReason: {
            type: "string",
            id: 15
          },
          status: {
            type: "CExchangeOrderStatus",
            id: 16
          }
        }
      },
      SortEnum: {
        values: {
          SortInit: 0,
          SELF_SUPPORT: 1,
          USER_DEPLOY: 2
        }
      },
      UserProductState: {
        values: {
          ON_SELL: 0,
          REMOVED: 1,
          PERRMANENTLY_REMOVED: 2,
          SOLR_OUT: 3
        }
      },
      ProductCommentStatue: {
        values: {
          AECS_NotReviewed: 0,
          AECS_Reviewed: 1,
          AECS_ReviewFail: 2
        }
      },
      UserType: {
        values: {
          ORDINARYUSER: 0,
          SMALLBUSSINESS: 1,
          ENTERPRISE: 2,
          STAFF: 3,
          TESTUSER: 4
        }
      },
      ExchangeOrderBigStatusEnum: {
        values: {
          EOBS_Init: 0,
          EOBS_UserDeliver: 1,
          EOBS_Check: 2,
          EOBS_receive: 3,
          EOBS_Success: 4,
          EOBS_Fatal: 5
        }
      },
      AdminMatchOrderListStatusEnum: {
        values: {
          MatchOrderListStatus_Default: 0,
          MatchOrderListStatus_EMOSToPay: 1,
          MatchOrderListStatus_EMOSHasPay: 2,
          MatchOrderListStatus_Refused: 3
        }
      },
      ExchangeProductStatusEnum: {
        values: {
          EPS_Init: 0,
          EPS_ToEvaluatePrice: 1,
          EPS_ConfirmPrice: 2,
          EPS_Matching: 3,
          EPS_Exchanging: 4,
          EPS_ExchangeSuccess: 5,
          EPS_ExchangeFailed: 6,
          EPS_ProductDown: 7,
          EPS_RejectConfirmPrice: 8
        }
      },
      ExchangeFeedItemStatue: {
        values: {
          EXCHANGE_SELL: 0,
          EXCHANGE: 1,
          SELL: 2,
          SHARE: 3
        }
      },
      ExchangeCardResourceStatue: {
        values: {
          EXCHANGE_APP: 0,
          EXCHANGE_WEAPP: 1,
          EXCHANGE_H5: 2
        }
      },
      AdminMallOrderCheckEnum: {
        values: {
          AMOC_Default: 0,
          AMOC_AppraisalFail: 1,
          AMOC_NewsFailed: 2,
          AMOC_OtherReason: 3,
          AMOC_CheckSuccess: 4
        }
      },
      PaymentType: {
        values: {
          Init: 0,
          WechatMiniProgram: 1,
          WechatPay: 2,
          AliPay: 3
        }
      },
      BuyerOrderStateEnum: {
        values: {
          BuyerOrderStateEnum_Init: 0,
          BuyerOrderStateEnum_ToBePaid: 1,
          BuyerOrderStateEnum_ToBeDelivered: 2,
          BuyerOrderStateEnum_ToBeReceived: 3,
          BuyerOrderStateEnum_SuccessfulTrade: 4,
          BuyerOrderStateEnum_FailedTrade: 5
        }
      },
      SellerOrderStateEnum: {
        values: {
          SellerOrderStateEnum_init: 0,
          SellerOrderStateEnum_OnSale: 1,
          SellerOrderStateEnum_ToBeDelivered: 2,
          SellerOrderStateEnum_HadDelivered: 3,
          SellerOrderStateEnum_SuccessfulTrade: 4,
          SellerOrderStateEnum_FailedTrade: 5
        }
      },
      MallOrderStatusEnum: {
        values: {
          MOSInit: 0,
          MOSWaitUserToBePay: 1,
          MOSWaitUserDeliver: 2,
          MOSWaitPlatformReceive: 3,
          MOSPlatformChecking: 4,
          MOSWaitPlatformDeliver: 5,
          MOSWaitUserReceive: 6,
          MOSTradeSuccess: 7,
          MOSPlatformSendBack: 8,
          MOSPlatformHasSendBack: 9,
          MOSTradeFailed: 10
        }
      },
      EditStautsEnum: {
        values: {
          ADD_INTERFACE: 0,
          MODIFY_INTERFACE: 1
        }
      },
      MallOrderButtonEnum: {
        values: {
          OrderButtonEnum_Init: 0,
          OrderButtonEnum_Delete: 1,
          OrderButtonEnum_Detail: 2,
          OrderButtonEnum_Deliver: 3,
          OrderButtonEnum_NotSell: 4,
          OrderButtonEnum_Express: 5,
          OrderButtonEnum_Pay: 6,
          OrderButtonEnum_CancelOrder: 7,
          OrderButtonEnum_ConfirmReceive: 8,
          OrderButtonEnum_Closed: 9,
          OrderButtonEnum_PutOnShelf: 10,
          OrderButtonEnum_Edit: 11,
          OrderButtonEnum_ModifyAddress: 12
        }
      },
      AdminMallOrderButtonEnum: {
        values: {
          AMOBE_Init: 0,
          AMOBE_Cancel: 1,
          AMOBE_ConfirmReceive: 2,
          AMOBE_Check: 3,
          AMOBE_Deliver: 4,
          AMOBE_SendBack: 5
        }
      },
      PsProductStatusEnum: {
        values: {
          PPSE_Init: 0,
          PPSE_Check: 1,
          PPSE_OnSell: 2,
          PPSE_Sold: 3,
          PPSE_TemporaryDown: 4,
          PPSE_PermanentDown: 5,
          PPSE_NotSell: 6,
          PPSE_Deleted: 7
        }
      },
      PsProductTypeEnum: {
        values: {
          PsProductInit: 0,
          PsProductTypeUser: 1,
          PsProductTypePlatform: 2,
          PsStockProductTypePlatform: 3
        }
      },
      PsProductPageTypeEnum: {
        values: {
          PsProductPageInit: 0,
          PsProductPageActivityBanner: 1,
          PsProductPagexxx: 2
        }
      },
      PsStockProductStatusEnum: {
        values: {
          PPSP_Init: 0,
          PPSP_OnSell: 1,
          PPSP_Undercarriage: 2,
          PPSP_PermanentlyOffShelf: 3
        }
      },
      AdminMatchOrderAttrEnum: {
        values: {
          MatchOrderAttr_Default: 0,
          MatchOrderAttr_User: 1,
          MatchOrderAttr_Spider: 2
        }
      },
      AdminMatchOrderStatusEnum: {
        values: {
          MatchOrderStatus_Default: 0,
          MatchOrderStatus_ToConfirmY: 1,
          MatchOrderStatus_ToConfirmI: 2,
          MatchOrderStatus_ToPay: 3,
          MatchOrderStatus_Payed: 4,
          MatchOrderStatus_canceled: 5
        }
      },
      AdminMatchOrderSourceEnum: {
        values: {
          MatchOrderSource_Default: 0,
          MatchOrderSource_Android: 1,
          MatchOrderSource_IOS: 2
        }
      },
      AdminOrderCStatusEnum: {
        values: {
          COrderStatus_Default: 0,
          COrderStatus_UserGot: 1,
          COrderStatus_PlatToSend: 2,
          COrderStatus_PlatSended: 3,
          COrderStatus_PlatToConfirm: 4,
          COrderStatus_PlatToCheck: 5,
          COrderStatus_ExchangeSuccess: 6,
          COrderStatus_ExchangeFailed: 7,
          COrderStatus_PlatChecked: 8,
          COrderStatus_ToSend: 9,
          COrderStatus_Sended: 10,
          COrderStatus_PlatToBack: 11
        }
      },
      AdminCOrderButtonEnum: {
        values: {
          ACOBE_Init: 0,
          ACOBE_Cancel: 1,
          ACOBE_ConfirmReceive: 2,
          ACOBE_Check: 3,
          ACOBE_Deliver: 4,
          ACOBE_SendBack: 5
        }
      },
      PlatformEnum: {
        values: {
          PLAT_Init: 0,
          PLAT_Ios: 1,
          PLAT_Android: 2,
          PLAT_WxMiniApp: 3
        }
      },
      MatchStatusEnum: {
        values: {
          INIT: 0,
          TOBECONFIRM: 1,
          CONFIRM: 2,
          REFUSED: 3,
          TOBEPAID: 4,
          PAID: 5,
          TOBEREFUNDED: 6,
          REFUNDED: 7,
          SUCCEED: 8,
          Failed: 9
        }
      },
      PExchangeOrderStatus: {
        values: {
          EO_Init: 0,
          EO_WaitUserDeliver: 1,
          EO_WaitPlatReceive: 2,
          EO_PlatChecking: 3,
          EO_WaitPlatDeliver: 4,
          EO_WaitUserReceive: 5,
          EO_TradeSucceed: 6,
          EO_TradeFailed: 7
        }
      },
      CExchangeOrderStatus: {
        values: {
          ESO_Init: 0,
          ESO_WaitUserDeliver: 1,
          ESO_WaitPlatReceive: 2,
          ESO_PlatChecking: 3,
          ESO_PlatCheckSuccess: 4,
          ESO_WaitPlatDeliver: 5,
          ESO_WaitUserReceive: 6,
          ESO_TradeSuccess: 7,
          ESO_WaitPlatSendBack: 8,
          ESO_TradeFailed: 9
        }
      },
      ProductPoolStatus: {
        values: {
          PPS_All: 0,
          PPS_Enable: 1,
          PPS_Unable: 2
        }
      },
      TSAdminPreFilterKindEnum: {
        values: {
          PreFilterKindDefault: 0,
          PreFilterKindNews: 1,
          PreFilterKindAppraisalPoint: 2,
          PreFilterKindOther: 3,
          PreFilterKindHomePic: 4
        }
      },
      TSAdminPreFilterHierarchyEnum: {
        values: {
          PreFilterHierarchyDefault: 0,
          PreFilterHierarchyBrand: 1,
          PreFilterHierarchyKind: 2,
          PreFilterHierarchySeries: 3
        }
      },
      OpenScreenAdType: {
        values: {
          OS_Init: 0,
          OS_Video: 1,
          OS_Picture: 2
        }
      },
      OpenScreenAdLinkType: {
        values: {
          OSAD_Init: 0,
          OSAD_H5: 1,
          OSAD_APP: 2,
          OSAD_Applet: 3
        }
      },
      OpenScreenAdState: {
        values: {
          OSAS_Init: 0,
          OSAS_Deactivate: 1,
          OSAS_ToBeEffective: 2,
          OSAS_InEffect: 3,
          OSAS_Expired: 4
        }
      },
      OperationType: {
        values: {
          OT_Init: 0,
          OT_Enable: 1,
          OT_Disable: 2,
          OT_Delete: 3
        }
      },
      TriggerEventType: {
        values: {
          TE_Init: 0,
          TE_OpenPage: 1,
          TE_ReadPage: 2
        }
      },
      SendWordType: {
        values: {
          ST_SIMPLE: 0,
          ST_WORD_PICTURE: 1
        }
      },
      SendWordDetailType: {
        values: {
          SD_INIT: 0,
          SD_TITLE: 1,
          SD_WORD: 2,
          SD_PICTURE: 3
        }
      },
      ScImageInfo: {
        fields: {
          position: {
            type: "string",
            id: 1
          },
          imageUrl: {
            type: "string",
            id: 2
          },
          required: {
            type: "bool",
            id: 3
          },
          pointId: {
            type: "int32",
            id: 4
          },
          imageType: {
            type: "string",
            id: 5
          },
          exampleImg: {
            type: "string",
            id: 6
          },
          index: {
            type: "int32",
            id: 7
          },
          pointKey: {
            type: "string",
            id: 8
          },
          singleKey: {
            type: "string",
            id: 9
          },
          smallStickFigure: {
            type: "string",
            id: 10
          },
          bigStickFigure: {
            type: "string",
            id: 11
          }
        }
      },
      UserInfo: {
        fields: {
          avatar: {
            type: "string",
            id: 1
          },
          name: {
            type: "string",
            id: 2
          },
          exchangeNum: {
            type: "int32",
            id: 3
          },
          releaseNum: {
            type: "int32",
            id: 4
          },
          isFollow: {
            type: "bool",
            id: 5
          }
        }
      },
      BannerItem: {
        fields: {
          imageUrl: {
            type: "string",
            id: 1
          },
          jumpLink: {
            type: "string",
            id: 2
          },
          jumpType: {
            type: "ExchangeCardResourceStatue",
            id: 3
          }
        }
      },
      LabelItem: {
        fields: {
          id: {
            type: "int32",
            id: 1
          },
          lid: {
            type: "string",
            id: 2
          },
          index: {
            type: "int32",
            id: 3
          },
          name: {
            type: "string",
            id: 4
          },
          status: {
            type: "bool",
            id: 5
          }
        }
      },
      CommentItem: {
        fields: {
          username: {
            type: "string",
            id: 1
          },
          content: {
            type: "string",
            id: 2
          },
          date: {
            type: "string",
            id: 3
          }
        }
      },
      ExchangeItem: {
        fields: {
          id: {
            type: "int32",
            id: 1
          },
          imgUrl: {
            type: "string",
            id: 2
          }
        }
      },
      ScProductDTO: {
        fields: {
          pid: {
            type: "string",
            id: 1
          },
          productName: {
            type: "string",
            id: 2
          },
          price: {
            type: "int32",
            id: 3
          },
          appearancePic: {
            type: "string",
            id: 4
          },
          newsName: {
            type: "string",
            id: 5
          },
          brandName: {
            type: "string",
            id: 6
          },
          kindName: {
            type: "string",
            id: 7
          },
          measurement: {
            type: "string",
            id: 8
          },
          mainPic: {
            type: "string",
            id: 9
          },
          color: {
            type: "string",
            id: 10
          },
          sendWords: {
            type: "string",
            id: 11
          },
          imgList: {
            rule: "repeated",
            type: "ScImageInfo",
            id: 12
          },
          status: {
            type: "PsProductStatusEnum",
            id: 13
          },
          isShare: {
            type: "bool",
            id: 14
          },
          canExchange: {
            type: "bool",
            id: 15
          },
          canSell: {
            type: "bool",
            id: 16
          },
          title: {
            type: "string",
            id: 17
          },
          likeCount: {
            type: "int32",
            id: 18
          },
          isLike: {
            type: "bool",
            id: 19
          },
          size: {
            type: "string",
            id: 20
          },
          officialPrice: {
            type: "int32",
            id: 22
          },
          brandStory: {
            type: "string",
            id: 23
          },
          leftNum: {
            type: "int32",
            id: 24
          },
          totalNum: {
            type: "int32",
            id: 25
          },
          logoImg: {
            type: "string",
            id: 26
          },
          sendWordType: {
            type: "SendWordType",
            id: 27
          },
          sendwordList: {
            rule: "repeated",
            type: "SendWordItem",
            id: 28
          }
        }
      },
      PsProductItem: {
        fields: {
          newsName: {
            type: "string",
            id: 1
          },
          productName: {
            type: "string",
            id: 2
          },
          pid: {
            type: "string",
            id: 3
          },
          price: {
            type: "int32",
            id: 4
          },
          appearanceImgUrl: {
            type: "string",
            id: 5
          },
          brandName: {
            type: "string",
            id: 6
          },
          kindName: {
            type: "string",
            id: 7
          },
          measurement: {
            type: "string",
            id: 8
          },
          mainPic: {
            type: "string",
            id: 9
          },
          color: {
            type: "string",
            id: 10
          },
          status: {
            type: "PsProductStatusEnum",
            id: 11
          },
          productType: {
            type: "PsProductTypeEnum",
            id: 12
          },
          SendWords: {
            type: "string",
            id: 13
          },
          imageList: {
            rule: "repeated",
            type: "ScImageInfo",
            id: 14
          },
          note: {
            type: "string",
            id: 15
          },
          tag: {
            type: "string",
            id: 16
          },
          isShare: {
            type: "bool",
            id: 17
          },
          isEffective: {
            type: "bool",
            id: 18
          },
          isCheck: {
            type: "bool",
            id: 19
          },
          buyNum: {
            type: "int32",
            id: 20
          },
          sku: {
            type: "string",
            id: 21
          },
          sendWordType: {
            type: "SendWordType",
            id: 22
          },
          sendwordList: {
            rule: "repeated",
            type: "SendWordItem",
            id: 23
          }
        }
      },
      MallOrderITem: {
        fields: {
          orderNo: {
            type: "string",
            id: 1
          },
          totalAmount: {
            type: "int32",
            id: 2
          },
          price: {
            type: "int32",
            id: 3
          },
          transferFee: {
            type: "int32",
            id: 4
          },
          expressFee: {
            type: "int32",
            id: 5
          },
          orderState: {
            type: "MallOrderStatusEnum",
            id: 6
          },
          buyTime: {
            type: "string",
            id: 7
          }
        }
      },
      PsUserAddress: {
        fields: {
          addressID: {
            type: "int32",
            id: 1
          },
          recipient: {
            type: "string",
            id: 2
          },
          phone: {
            type: "string",
            id: 3
          },
          province: {
            type: "string",
            id: 4
          },
          city: {
            type: "string",
            id: 5
          },
          regions: {
            type: "string",
            id: 6
          },
          detailAddress: {
            type: "string",
            id: 7
          },
          isDefault: {
            type: "bool",
            id: 8
          },
          nickName: {
            type: "string",
            id: 9
          },
          sellerPhoneNum: {
            type: "string",
            id: 10
          }
        }
      },
      PsExpressRecord: {
        fields: {
          updateTime: {
            type: "string",
            id: 1
          },
          content: {
            type: "string",
            id: 2
          },
          comment: {
            type: "string",
            id: 3
          }
        }
      },
      AddressItem: {
        fields: {
          uid: {
            type: "string",
            id: 1
          },
          nickname: {
            type: "string",
            id: 2
          },
          addressee: {
            type: "string",
            id: 3
          },
          phone: {
            type: "string",
            id: 4
          },
          address: {
            type: "string",
            id: 5
          },
          addressPhone: {
            type: "string",
            id: 6
          }
        }
      },
      OrderBaseInfo: {
        fields: {
          orderNo: {
            type: "string",
            id: 1
          },
          orderStateEnum: {
            type: "MallOrderStatusEnum",
            id: 2
          },
          state: {
            type: "string",
            id: 3
          },
          stateIntroduction: {
            type: "string",
            id: 4
          },
          orderPrice: {
            type: "int32",
            id: 5
          },
          payType: {
            type: "PaymentType",
            id: 6
          },
          createTime: {
            type: "string",
            id: 7
          },
          remainingTime: {
            type: "int32",
            id: 8
          }
        }
      },
      MallOrderButton: {
        fields: {
          buttonEnum: {
            type: "MallOrderButtonEnum",
            id: 1
          },
          buttonTitle: {
            type: "string",
            id: 2
          }
        }
      },
      MallBuyerBriefOrderInfo: {
        fields: {
          orderBaseInfo: {
            type: "OrderBaseInfo",
            id: 1
          },
          productInfo: {
            type: "PsProductItem",
            id: 2
          },
          orderButton: {
            rule: "repeated",
            type: "MallOrderButton",
            id: 3
          }
        }
      },
      MallSellerBriefOrderInfo: {
        fields: {
          orderBaseInfo: {
            type: "OrderBaseInfo",
            id: 1
          },
          productInfo: {
            type: "PsProductItem",
            id: 2
          },
          orderButton: {
            rule: "repeated",
            type: "MallOrderButton",
            id: 3
          }
        }
      },
      MallOrderBaseInfo: {
        fields: {
          orderNo: {
            type: "string",
            id: 1
          },
          payAmount: {
            type: "int32",
            id: 2
          },
          expressFee: {
            type: "int32",
            id: 3
          },
          creatTime: {
            type: "string",
            id: 4
          },
          payType: {
            type: "PaymentType",
            id: 5
          },
          expressNo: {
            type: "string",
            id: 6
          }
        }
      },
      MallBuyerOrderDetailInfo: {
        fields: {
          orderInfo: {
            type: "MallOrderBaseInfo",
            id: 1
          },
          OrdeoStateEnum: {
            type: "MallOrderStatusEnum",
            id: 2
          },
          productinfo: {
            type: "PsProductItem",
            id: 3
          },
          receivingAddress: {
            type: "PsUserAddress",
            id: 4
          },
          payTimeout: {
            type: "string",
            id: 5
          },
          record: {
            type: "PsExpressRecord",
            id: 6
          }
        }
      },
      OrderButton: {
        fields: {
          buttonEnum: {
            type: "MallOrderButtonEnum",
            id: 1
          },
          buttonTitle: {
            type: "string",
            id: 2
          }
        }
      },
      AdminMallOrderButton: {
        fields: {
          buttonEnum: {
            type: "AdminMallOrderButtonEnum",
            id: 1
          },
          buttonTitle: {
            type: "string",
            id: 2
          }
        }
      },
      PsExpressItem: {
        fields: {
          itemTitle: {
            type: "string",
            id: 1
          },
          itemState: {
            type: "bool",
            id: 2
          },
          hasDetail: {
            type: "bool",
            id: 3
          },
          expressCompany: {
            type: "string",
            id: 4
          },
          expressNumber: {
            type: "string",
            id: 5
          },
          records: {
            rule: "repeated",
            type: "PsExpressRecord",
            id: 6
          },
          isTitleHide: {
            type: "bool",
            id: 7
          }
        }
      },
      MatchButtonType: {
        values: {
          MOS_Init: 0,
          MOS_Accept: 1,
          MOS_Refuse: 2,
          MOS_Delete: 3,
          MOS_Pay: 4,
          MOS_Cancel: 5,
          MOS_Remark: 6,
          MOS_Detail: 7
        }
      },
      MatchButton: {
        fields: {
          type: {
            type: "MatchButtonType",
            id: 1
          },
          title: {
            type: "string",
            id: 2
          }
        }
      },
      ExpressFlowItem: {
        fields: {
          title: {
            type: "string",
            id: 1
          },
          iconUrl: {
            type: "string",
            id: 2
          },
          isLight: {
            type: "bool",
            id: 3
          }
        }
      },
      ExchangeButton: {
        fields: {
          btnType: {
            type: "Type",
            id: 1
          },
          title: {
            type: "string",
            id: 2
          }
        },
        nested: {
          Type: {
            values: {
              Init: 0,
              Deliver: 1,
              Logistics: 2,
              ConfirmReceive: 3,
              Detail: 4,
              Remark: 5,
              Cancel: 6,
              SendBack: 7,
              Check: 8
            }
          }
        }
      },
      ProductPoolBtn: {
        fields: {
          btnType: {
            type: "Type",
            id: 1
          },
          title: {
            type: "string",
            id: 2
          }
        },
        nested: {
          Type: {
            values: {
              Init: 0,
              Detail: 1,
              Remark: 2,
              Enable: 3,
              Unable: 4
            }
          }
        }
      },
      SendWordItem: {
        fields: {
          type: {
            type: "SendWordDetailType",
            id: 1
          },
          value: {
            type: "string",
            id: 2
          },
          order: {
            type: "int32",
            id: 3
          }
        }
      },
      AdminMatchOrderItem: {
        fields: {
          pMatchNo: {
            type: "string",
            id: 1
          },
          cMatchNo: {
            type: "string",
            id: 2
          },
          userAttr: {
            type: "AdminMatchOrderAttrEnum",
            id: 3
          },
          phoneNum: {
            type: "string",
            id: 4
          },
          pid: {
            type: "string",
            id: 5
          },
          matchPid: {
            type: "string",
            id: 6
          },
          payMoney: {
            type: "int32",
            id: 7
          },
          status: {
            type: "MatchStatusEnum",
            id: 8
          },
          matchStatusName: {
            type: "string",
            id: 9
          },
          remark: {
            type: "string",
            id: 10
          },
          matchTime: {
            type: "int32",
            id: 11
          },
          buttonList: {
            rule: "repeated",
            type: "MatchButton",
            id: 12
          }
        }
      },
      TsAdminExchangeMatchOrderListRequest: {
        fields: {
          pMatchNo: {
            type: "string",
            id: 1
          },
          cMatchNo: {
            type: "string",
            id: 2
          },
          userAttr: {
            type: "AdminMatchOrderAttrEnum",
            id: 3
          },
          phoneNum: {
            type: "string",
            id: 4
          },
          pid: {
            type: "string",
            id: 5
          },
          status: {
            type: "MatchStatusEnum",
            id: 6
          },
          remark: {
            type: "string",
            id: 7
          },
          startTime: {
            type: "int32",
            id: 8
          },
          endTime: {
            type: "int32",
            id: 9
          },
          pageNum: {
            type: "int32",
            id: 10
          },
          pageSize: {
            type: "int32",
            id: 11
          }
        }
      },
      TSAdminExchangeMatchOrderListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          matchOrderlist: {
            rule: "repeated",
            type: "AdminMatchOrderItem",
            id: 3
          },
          total: {
            type: "int32",
            id: 4
          }
        }
      },
      TsAdminExchangeMatchOrderRemarkRequest: {
        fields: {
          cMatchNo: {
            type: "string",
            id: 1
          },
          remark: {
            type: "string",
            id: 2
          }
        }
      },
      TsAdminExchangeMatchOrderRemarkResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TsAdminExchangeMatchOrderCancelRequest: {
        fields: {
          cMatchNo: {
            type: "string",
            id: 1
          }
        }
      },
      TsAdminExchangeMatchOrderCancelResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TsAdminExchangeMatchOrderDetailRequest: {
        fields: {
          cMatchNo: {
            type: "string",
            id: 1
          }
        }
      },
      TsAdminExchangeMatchOrderDetailResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          basicInfo: {
            type: "BasicMessage",
            id: 3
          },
          affiliationInfo: {
            type: "UserInfo",
            id: 5
          },
          userInfo: {
            type: "UserInfo",
            id: 4
          }
        },
        nested: {
          BasicMessage: {
            fields: {
              matchOrderNo: {
                type: "string",
                id: 1
              },
              orderSource: {
                type: "PlatformEnum",
                id: 2
              },
              matchStatusName: {
                type: "string",
                id: 3
              },
              deliverFee: {
                type: "int32",
                id: 4
              },
              status: {
                type: "MatchStatusEnum",
                id: 5
              },
              payType: {
                type: "PaymentType",
                id: 6
              },
              realPay: {
                type: "int32",
                id: 7
              },
              matchTime: {
                type: "int32",
                id: 8
              },
              payTime: {
                type: "int32",
                id: 9
              },
              handleFee: {
                type: "int32",
                id: 10
              },
              subPrice: {
                type: "int32",
                id: 11
              },
              buttonList: {
                rule: "repeated",
                type: "MatchButton",
                id: 12
              }
            }
          },
          UserInfo: {
            fields: {
              user: {
                type: "string",
                id: 1
              },
              userAddress: {
                type: "AddressInfo",
                id: 2
              },
              phoneNum: {
                type: "string",
                id: 3
              },
              nickName: {
                type: "string",
                id: 4
              }
            },
            nested: {
              AddressInfo: {
                fields: {
                  name: {
                    type: "string",
                    id: 1
                  },
                  address: {
                    type: "string",
                    id: 2
                  },
                  phoneNo: {
                    type: "string",
                    id: 3
                  }
                }
              }
            }
          }
        }
      },
      TSAdminMallOrderListRequest: {
        fields: {
          pageNum: {
            type: "int32",
            id: 1
          },
          pageSize: {
            type: "int32",
            id: 2
          },
          orderNo: {
            type: "string",
            id: 3
          },
          sellerPhone: {
            type: "string",
            id: 5
          },
          buyerPhone: {
            type: "string",
            id: 6
          },
          state: {
            type: "MallOrderStatusEnum",
            id: 7
          },
          expressNo: {
            type: "string",
            id: 8
          },
          pid: {
            type: "string",
            id: 9
          },
          note: {
            type: "string",
            id: 10
          },
          startTime: {
            type: "string",
            id: 11
          },
          endTime: {
            type: "string",
            id: 12
          },
          productType: {
            type: "PsProductTypeEnum",
            id: 13
          }
        }
      },
      TSAdminMallOrderListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          itemList: {
            rule: "repeated",
            type: "AdminMallOrderBrief",
            id: 3
          },
          totalCount: {
            type: "int32",
            id: 4
          }
        }
      },
      AdminMallOrderBrief: {
        fields: {
          orderNo: {
            type: "string",
            id: 1
          },
          buyerPhone: {
            type: "string",
            id: 2
          },
          sellerPhone: {
            type: "string",
            id: 3
          },
          pid: {
            type: "string",
            id: 4
          },
          productName: {
            type: "string",
            id: 5
          },
          note: {
            type: "string",
            id: 6
          },
          actualPrice: {
            type: "int32",
            id: 7
          },
          state: {
            type: "MallOrderStatusEnum",
            id: 8
          },
          stateText: {
            type: "string",
            id: 9
          },
          orderTime: {
            type: "string",
            id: 10
          },
          buttonList: {
            rule: "repeated",
            type: "AdminMallOrderButton",
            id: 11
          },
          productType: {
            type: "PsProductTypeEnum",
            id: 13
          },
          expressNo: {
            type: "string",
            id: 14
          }
        }
      },
      TSAdminPsOperationListRequest: {
        fields: {
          pageSize: {
            type: "int32",
            id: 1
          },
          pageNum: {
            type: "int32",
            id: 2
          },
          orderNo: {
            type: "string",
            id: 3
          },
          pid: {
            type: "string",
            id: 4
          }
        }
      },
      TSAdminPsOperationListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          recordList: {
            rule: "repeated",
            type: "Record",
            id: 3
          },
          totalCount: {
            type: "int32",
            id: 4
          }
        },
        nested: {
          Record: {
            fields: {
              pid: {
                type: "string",
                id: 1
              },
              createTime: {
                type: "string",
                id: 2
              },
              isUser: {
                type: "bool",
                id: 3
              },
              name: {
                type: "string",
                id: 4
              },
              mobile: {
                type: "string",
                id: 5
              },
              operate: {
                type: "string",
                id: 6
              },
              orderNo: {
                type: "string",
                id: 7
              }
            }
          }
        }
      },
      TSAdminMallOrderNoteRequest: {
        fields: {
          orderNo: {
            type: "string",
            id: 1
          },
          note: {
            type: "string",
            id: 2
          }
        }
      },
      TSAdminMallOrderNoteResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSAdminMallOrderDetailRequest: {
        fields: {
          orderNo: {
            type: "string",
            id: 1
          }
        }
      },
      TSAdminMallOrderDetailResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          baseOrder: {
            type: "PsAdminBaseOrderInfo",
            id: 3
          },
          buyerAddress: {
            type: "AddressItem",
            id: 4
          },
          productInfo: {
            type: "PsProductBaseInfo",
            id: 5
          },
          sellerAddress: {
            type: "AddressItem",
            id: 7
          },
          sellerProductInfo: {
            type: "PsProductItem",
            id: 8
          }
        }
      },
      PsAdminBaseOrderInfo: {
        fields: {
          orderNo: {
            type: "string",
            id: 1
          },
          source: {
            type: "string",
            id: 2
          },
          productPrice: {
            type: "int32",
            id: 3
          },
          sellerDeliverTime: {
            type: "string",
            id: 4
          },
          platformReceiveTime: {
            type: "string",
            id: 5
          },
          state: {
            type: "MallOrderStatusEnum",
            id: 6
          },
          payType: {
            type: "PaymentType",
            id: 7
          },
          deliverFee: {
            type: "int32",
            id: 8
          },
          sellerExpressNo: {
            type: "string",
            id: 9
          },
          platformDeliverTime: {
            type: "string",
            id: 10
          },
          orderTime: {
            type: "string",
            id: 11
          },
          payTime: {
            type: "string",
            id: 12
          },
          actualPay: {
            type: "int32",
            id: 13
          },
          platformExpressNo: {
            type: "string",
            id: 14
          },
          buyerReceiveTime: {
            type: "string",
            id: 15
          },
          failedReason: {
            type: "string",
            id: 16
          },
          transfee: {
            type: "string",
            id: 17
          },
          note: {
            type: "string",
            id: 18
          }
        }
      },
      PsProductBaseInfo: {
        fields: {
          skc: {
            type: "string",
            id: 1
          },
          itemID: {
            type: "string",
            id: 2
          },
          sku: {
            type: "string",
            id: 3
          },
          kind: {
            type: "string",
            id: 4
          },
          brand: {
            type: "string",
            id: 5
          },
          name: {
            type: "string",
            id: 6
          },
          color: {
            type: "string",
            id: 7
          },
          size: {
            type: "string",
            id: 8
          },
          series: {
            type: "string",
            id: 9
          },
          measurement: {
            type: "string",
            id: 10
          },
          people: {
            type: "string",
            id: 11
          },
          material: {
            type: "string",
            id: 12
          },
          style: {
            type: "string",
            id: 13
          },
          releasePrice: {
            type: "int32",
            id: 14
          },
          releaseTime: {
            type: "string",
            id: 15
          },
          kindId: {
            type: "int32",
            id: 16
          },
          spu: {
            type: "string",
            id: 17
          },
          tags: {
            type: "string",
            id: 18
          }
        }
      },
      TSAdminMallOrderReceiveRequest: {
        fields: {
          orderNo: {
            type: "string",
            id: 1
          }
        }
      },
      TSAdminMallOrderReceiveResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSAdminMallOrderCheckRequest: {
        fields: {
          orderNo: {
            type: "string",
            id: 1
          },
          checkFailed: {
            type: "bool",
            id: 2
          }
        }
      },
      TSAdminMallOrderCheckResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSAdminMallOrderDeliverRequest: {
        fields: {
          expressNo: {
            type: "string",
            id: 1
          },
          orderNo: {
            type: "string",
            id: 2
          }
        }
      },
      TSAdminMallOrderDeliverResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSAdminMallCancelOrderRequest: {
        fields: {
          orderNo: {
            type: "string",
            id: 1
          }
        }
      },
      TSAdminMallCancelOrderResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSAdminMallSendBackRequest: {
        fields: {
          expressNo: {
            type: "string",
            id: 1
          },
          orderNo: {
            type: "string",
            id: 2
          }
        }
      },
      TSAdminMallSendBackResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSAdminProductListRequest: {
        fields: {
          pageSize: {
            type: "int32",
            id: 1
          },
          pageNum: {
            type: "int32",
            id: 2
          },
          pid: {
            type: "string",
            id: 3
          },
          sku: {
            type: "string",
            id: 4
          },
          title: {
            type: "string",
            id: 5
          },
          kindId: {
            type: "string",
            id: 6
          },
          sellerPhone: {
            type: "string",
            id: 7
          },
          tagIds: {
            rule: "repeated",
            type: "string",
            id: 8
          },
          remark: {
            type: "string",
            id: 9
          },
          type: {
            type: "PsProductTypeEnum",
            id: 10
          },
          status: {
            type: "PsProductStatusEnum",
            id: 11
          },
          startTime: {
            type: "string",
            id: 12
          },
          endTime: {
            type: "string",
            id: 13
          },
          brandId: {
            type: "string",
            id: 14
          }
        }
      },
      TSAdminProductListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          productList: {
            rule: "repeated",
            type: "Product",
            id: 3
          },
          total: {
            type: "int32",
            id: 4
          }
        },
        nested: {
          Product: {
            fields: {
              pid: {
                type: "string",
                id: 1
              },
              title: {
                type: "string",
                id: 2
              },
              price: {
                type: "int32",
                id: 3
              },
              appearancePic: {
                type: "string",
                id: 4
              },
              kindName: {
                type: "string",
                id: 5
              },
              remark: {
                type: "string",
                id: 6
              },
              status: {
                type: "PsProductStatusEnum",
                id: 7
              },
              canExchange: {
                type: "bool",
                id: 8
              },
              canSell: {
                type: "bool",
                id: 9
              },
              sellerPhone: {
                type: "string",
                id: 10
              },
              publishTime: {
                type: "string",
                id: 11
              },
              costPrice: {
                type: "int32",
                id: 12
              },
              tagsName: {
                rule: "repeated",
                type: "string",
                id: 13
              },
              sku: {
                type: "string",
                id: 14
              },
              ProductType: {
                type: "PsProductTypeEnum",
                id: 15
              },
              brandName: {
                type: "string",
                id: 16
              }
            }
          }
        }
      },
      TSAdminProductDetailRequest: {
        fields: {
          pid: {
            type: "string",
            id: 1
          }
        }
      },
      TSAdminProductDetailResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          basicInfo: {
            type: "Basic",
            id: 3
          },
          product: {
            type: "Product",
            id: 4
          },
          seller: {
            type: "UserInfo",
            id: 5
          }
        },
        nested: {
          Basic: {
            fields: {
              spu: {
                type: "string",
                id: 1
              },
              skc: {
                type: "string",
                id: 2
              },
              sku: {
                type: "string",
                id: 3
              },
              kindName: {
                type: "string",
                id: 4
              },
              brandName: {
                type: "string",
                id: 5
              },
              SeriesName: {
                type: "string",
                id: 6
              },
              ColorName: {
                type: "string",
                id: 7
              },
              Material: {
                type: "string",
                id: 8
              },
              ReleasePrice: {
                type: "int32",
                id: 11
              },
              AdaptCrowd: {
                type: "string",
                id: 12
              },
              Image: {
                type: "string",
                id: 14
              },
              Name: {
                type: "string",
                id: 15
              },
              SizeName: {
                type: "string",
                id: 16
              },
              Measurement: {
                type: "string",
                id: 17
              },
              ReleaseDate: {
                type: "string",
                id: 18
              }
            }
          },
          Tag: {
            fields: {
              tid: {
                type: "string",
                id: 1
              },
              tName: {
                type: "string",
                id: 2
              }
            }
          },
          Product: {
            fields: {
              pid: {
                type: "string",
                id: 1
              },
              price: {
                type: "int32",
                id: 2
              },
              appearancePic: {
                type: "string",
                id: 3
              },
              newsId: {
                type: "int32",
                id: 4
              },
              newsName: {
                type: "string",
                id: 5
              },
              sendWords: {
                type: "string",
                id: 6
              },
              imgList: {
                rule: "repeated",
                type: "ScImageInfo",
                id: 7
              },
              status: {
                type: "PsProductStatusEnum",
                id: 8
              },
              canExchange: {
                type: "bool",
                id: 9
              },
              canSell: {
                type: "bool",
                id: 10
              },
              title: {
                type: "string",
                id: 11
              },
              type: {
                type: "PsProductTypeEnum",
                id: 12
              },
              costPrice: {
                type: "int32",
                id: 13
              },
              tagList: {
                rule: "repeated",
                type: "Tag",
                id: 14
              },
              remark: {
                type: "string",
                id: 15
              },
              BrandId: {
                type: "int32",
                id: 16
              },
              sendWordType: {
                type: "SendWordType",
                id: 17
              },
              sendwordList: {
                rule: "repeated",
                type: "SendWordItem",
                id: 18
              }
            }
          },
          UserInfo: {
            fields: {
              nickName: {
                type: "string",
                id: 1
              },
              phoneNum: {
                type: "string",
                id: 2
              }
            }
          }
        }
      },
      TSAdminProductSaveRequest: {
        fields: {
          pid: {
            type: "string",
            id: 1
          },
          sku: {
            type: "string",
            id: 2
          },
          sendWord: {
            type: "string",
            id: 3
          },
          imgList: {
            rule: "repeated",
            type: "ScImageInfo",
            id: 4
          },
          newsId: {
            type: "int32",
            id: 5
          },
          price: {
            type: "int32",
            id: 6
          },
          tagIds: {
            rule: "repeated",
            type: "string",
            id: 7
          },
          exchangeable: {
            type: "bool",
            id: 8
          },
          saleable: {
            type: "bool",
            id: 9
          },
          type: {
            type: "PsProductTypeEnum",
            id: 10
          },
          remark: {
            type: "string",
            id: 11
          },
          sellerPhone: {
            type: "string",
            id: 12
          },
          title: {
            type: "string",
            id: 13
          },
          costPrice: {
            type: "int32",
            id: 14
          },
          sendWordType: {
            type: "SendWordType",
            id: 15
          },
          sendwordList: {
            rule: "repeated",
            type: "SendWordItem",
            id: 16
          }
        }
      },
      TSAdminProductSaveResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSAdminProductShareListRequest: {
        fields: {
          remark: {
            type: "string",
            id: 1
          },
          phoneNum: {
            type: "string",
            id: 2
          },
          pid: {
            type: "string",
            id: 3
          },
          productType: {
            type: "PsProductTypeEnum",
            id: 4
          },
          title: {
            type: "string",
            id: 5
          },
          tagIds: {
            rule: "repeated",
            type: "string",
            id: 6
          },
          startTime: {
            type: "string",
            id: 7
          },
          endTime: {
            type: "string",
            id: 8
          },
          status: {
            type: "PsProductStatusEnum",
            id: 9
          },
          pageSize: {
            type: "int32",
            id: 10
          },
          pageNum: {
            type: "int32",
            id: 11
          }
        }
      },
      TSAdminProductShareListResponse: {
        fields: {
          shareList: {
            rule: "repeated",
            type: "ShareItem",
            id: 1
          },
          errorCode: {
            type: "int32",
            id: 2
          },
          errorMsg: {
            type: "string",
            id: 3
          },
          total: {
            type: "int32",
            id: 4
          }
        },
        nested: {
          ShareItem: {
            fields: {
              pid: {
                type: "string",
                id: 1
              },
              productType: {
                type: "PsProductTypeEnum",
                id: 2
              },
              status: {
                type: "PsProductStatusEnum",
                id: 3
              },
              title: {
                type: "string",
                id: 4
              },
              tagsName: {
                rule: "repeated",
                type: "string",
                id: 5
              },
              appearancePic: {
                type: "string",
                id: 6
              },
              phone: {
                type: "string",
                id: 7
              },
              pushTime: {
                type: "string",
                id: 8
              },
              remark: {
                type: "string",
                id: 9
              }
            }
          }
        }
      },
      TSAdminProductShareRequest: {
        fields: {
          productType: {
            type: "PsProductTypeEnum",
            id: 1
          },
          publishPhone: {
            type: "string",
            id: 2
          },
          title: {
            type: "string",
            id: 3
          },
          sendWords: {
            type: "string",
            id: 4
          },
          tagIds: {
            rule: "repeated",
            type: "string",
            id: 5
          },
          imgList: {
            rule: "repeated",
            type: "ScImageInfo",
            id: 6
          },
          price: {
            type: "int32",
            id: 7
          },
          remark: {
            type: "string",
            id: 8
          },
          pid: {
            type: "string",
            id: 9
          }
        }
      },
      TSAdminProductShareResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSAdminProductDelShareRequest: {
        fields: {
          pid: {
            type: "string",
            id: 1
          }
        }
      },
      TSAdminProductDelShareResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSAdminProductChangeTagRequest: {
        fields: {
          pid: {
            type: "string",
            id: 1
          },
          tagIds: {
            rule: "repeated",
            type: "string",
            id: 2
          }
        }
      },
      TSAdminProductChangeTagResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSAdminProductUpDownRequest: {
        fields: {
          pid: {
            type: "string",
            id: 1
          },
          down: {
            type: "bool",
            id: 2
          }
        }
      },
      TSAdminProductUpDownResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSAdminRemarkProductRequest: {
        fields: {
          pid: {
            type: "string",
            id: 1
          },
          remark: {
            type: "string",
            id: 2
          }
        }
      },
      TSAdminRemarkProductResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      ShareItem: {
        fields: {
          pid: {
            type: "int32",
            id: 1
          },
          sort: {
            type: "SortEnum",
            id: 2
          },
          imgUrl: {
            type: "string",
            id: 3
          },
          title: {
            type: "string",
            id: 4
          },
          labelList: {
            type: "string",
            id: 6
          },
          mark: {
            type: "string",
            id: 7
          },
          state: {
            type: "bool",
            id: 8
          },
          phoneNum: {
            type: "int32",
            id: 9
          },
          releaseTime: {
            type: "string",
            id: 10
          }
        }
      },
      ShareItemBaseInfo: {
        fields: {
          sort: {
            type: "SortEnum",
            id: 3
          },
          phoneNum: {
            type: "int32",
            id: 4
          },
          newsId: {
            type: "int32",
            id: 5
          },
          title: {
            type: "string",
            id: 6
          },
          description: {
            type: "string",
            id: 7
          },
          mark: {
            type: "string",
            id: 8
          },
          labelList: {
            rule: "repeated",
            type: "LabelItem",
            id: 9
          },
          sellPrice: {
            type: "int32",
            id: 10
          }
        }
      },
      UserProductItem: {
        fields: {
          pid: {
            type: "int32",
            id: 1
          },
          sku: {
            type: "string",
            id: 2
          },
          imgUrl: {
            type: "string",
            id: 3
          },
          title: {
            type: "string",
            id: 4
          },
          kindName: {
            type: "string",
            id: 5
          },
          sellerPhoneNum: {
            type: "string",
            id: 6
          },
          price: {
            type: "int32",
            id: 7
          },
          sortList: {
            type: "string",
            id: 8
          },
          labelList: {
            rule: "repeated",
            type: "LabelItem",
            id: 9
          },
          mark: {
            type: "string",
            id: 10
          },
          state: {
            type: "UserProductState",
            id: 11
          },
          releaseTime: {
            type: "string",
            id: 12
          },
          releaseDay: {
            type: "string",
            id: 13
          }
        }
      },
      BaseInfo: {
        fields: {
          kindId: {
            type: "int32",
            id: 1
          },
          kindName: {
            type: "string",
            id: 2
          },
          brandId: {
            type: "int32",
            id: 3
          },
          brandName: {
            type: "string",
            id: 4
          },
          seriesName: {
            type: "string",
            id: 5
          },
          productName: {
            type: "string",
            id: 6
          },
          imgUrl: {
            type: "string",
            id: 7
          },
          sku: {
            type: "string",
            id: 8
          },
          color: {
            type: "string",
            id: 9
          },
          size: {
            type: "string",
            id: 10
          },
          measurement: {
            type: "string",
            id: 11
          }
        }
      },
      ImageItem: {
        fields: {
          id: {
            type: "int32",
            id: 1
          },
          position: {
            type: "string",
            id: 2
          },
          require: {
            type: "bool",
            id: 3
          }
        }
      },
      TSAdminExchangeShareProductListRequest: {
        fields: {
          pageNum: {
            type: "int32",
            id: 1
          },
          pageSize: {
            type: "int32",
            id: 2
          },
          pid: {
            type: "int32",
            id: 3
          },
          sort: {
            type: "SortEnum",
            id: 4
          },
          title: {
            type: "string",
            id: 5
          },
          labelList: {
            type: "string",
            id: 6
          },
          mark: {
            type: "string",
            id: 7
          },
          phoneNum: {
            type: "int32",
            id: 8
          },
          state: {
            type: "bool",
            id: 9
          },
          startTime: {
            type: "string",
            id: 10
          },
          endTime: {
            type: "string",
            id: 11
          }
        }
      },
      TSAdminExchangeShareProductListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          shareList: {
            rule: "repeated",
            type: "ShareItem",
            id: 3
          }
        }
      },
      TSAdminExchangeShareProductAddRequest: {
        fields: {
          pid: {
            type: "int32",
            id: 1
          },
          type: {
            type: "string",
            id: 2
          },
          baseInfo: {
            type: "ShareItemBaseInfo",
            id: 3
          }
        }
      },
      TSAdminExchangeShareProductAddResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSAdminExchangeShareProductDetailRequest: {
        fields: {
          pid: {
            type: "int32",
            id: 1
          }
        }
      },
      TSAdminExchangeShareProductDetailResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          baseInfo: {
            type: "ShareItemBaseInfo",
            id: 3
          }
        }
      },
      ProductBaseInfo: {
        fields: {
          sort: {
            type: "SortEnum",
            id: 1
          },
          sellerPhoneNum: {
            type: "int32",
            id: 2
          },
          newsId: {
            type: "int32",
            id: 3
          },
          costPrice: {
            type: "int32",
            id: 4
          },
          sellPrice: {
            type: "int32",
            id: 5
          },
          title: {
            type: "string",
            id: 6
          },
          description: {
            type: "string",
            id: 7
          },
          labelList: {
            rule: "repeated",
            type: "LabelItem",
            id: 8
          },
          imageList: {
            rule: "repeated",
            type: "ImageItem",
            id: 9
          }
        }
      },
      TSAdminExchangeUserProductListRequest: {
        fields: {
          pageNum: {
            type: "int32",
            id: 1
          },
          pageSize: {
            type: "int32",
            id: 2
          },
          pid: {
            type: "int32",
            id: 3
          },
          sort: {
            type: "SortEnum",
            id: 4
          },
          title: {
            type: "string",
            id: 5
          },
          labelList: {
            type: "string",
            id: 6
          },
          mark: {
            type: "string",
            id: 7
          },
          phoneNum: {
            type: "int32",
            id: 8
          },
          state: {
            type: "bool",
            id: 9
          },
          startTime: {
            type: "string",
            id: 10
          },
          endTime: {
            type: "string",
            id: 11
          }
        }
      },
      TSAdminExchangeUserProductListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          productList: {
            rule: "repeated",
            type: "UserProductItem",
            id: 3
          }
        }
      },
      TSAdminExchangeProductAddEditRequest: {
        fields: {
          pid: {
            type: "int32",
            id: 1
          },
          type: {
            type: "string",
            id: 2
          },
          baseInfo: {
            type: "BaseInfo",
            id: 3
          },
          productBaseInfo: {
            type: "ProductBaseInfo",
            id: 4
          }
        }
      },
      TSAdminExchangeProductAddEditResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSAdminExchangeProductDetailRequest: {
        fields: {
          pid: {
            type: "int32",
            id: 1
          }
        }
      },
      ImgItem: {
        fields: {
          url: {
            type: "string",
            id: 1
          }
        }
      },
      CardResourceItem: {
        fields: {
          title: {
            type: "string",
            id: 1
          },
          content: {
            type: "string",
            id: 2
          },
          imgList: {
            rule: "repeated",
            type: "ImgItem",
            id: 3
          },
          position: {
            type: "int32",
            id: 4
          },
          upOrDown: {
            type: "int32",
            id: 5
          },
          cardType: {
            type: "ExchangeCardResourceStatue",
            id: 6
          },
          jumpUrl: {
            type: "string",
            id: 7
          },
          status: {
            type: "bool",
            id: 8
          },
          cardId: {
            type: "int32",
            id: 9
          }
        }
      },
      TSAdminExchangeCardResourceListRequest: {
        fields: {
          pageNum: {
            type: "int32",
            id: 1
          },
          pageSize: {
            type: "int32",
            id: 2
          },
          status: {
            type: "Status",
            id: 3
          }
        }
      },
      TSAdminExchangeCardResourceListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          cardResourceList: {
            rule: "repeated",
            type: "CardResourceItem",
            id: 3
          }
        }
      },
      TSAdminExchangeCardResourceAddEditRequest: {
        fields: {
          StautsType: {
            type: "EditStautsEnum",
            id: 1
          },
          cardId: {
            type: "int32",
            id: 2
          },
          title: {
            type: "string",
            id: 3
          },
          content: {
            type: "string",
            id: 4
          },
          position: {
            type: "int32",
            id: 5
          },
          upOrDown: {
            type: "int32",
            id: 6
          },
          imgList: {
            rule: "repeated",
            type: "ImgItem",
            id: 7
          },
          cardType: {
            type: "ExchangeCardResourceStatue",
            id: 8
          },
          jumpLink: {
            type: "string",
            id: 9
          }
        }
      },
      TSAdminExchangeCardResourceAddEditResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSAdminExchangeCardResourceStatusRequest: {
        fields: {
          status: {
            type: "bool",
            id: 1
          },
          cardId: {
            type: "int32",
            id: 2
          },
          position: {
            type: "int32",
            id: 3
          },
          upOrDown: {
            type: "int32",
            id: 4
          }
        }
      },
      TSAdminExchangeCardResourceStatusResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSAdminExchangeLabelListRequest: {
        fields: {
          pageNum: {
            type: "int32",
            id: 1
          },
          pageSize: {
            type: "int32",
            id: 2
          },
          status: {
            type: "Status",
            id: 3
          },
          name: {
            type: "string",
            id: 4
          }
        }
      },
      Status: {
        values: {
          It: 0,
          Enable: 1,
          Disable: 2
        }
      },
      TSAdminExchangeLabelListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          labelList: {
            rule: "repeated",
            type: "LabelItem",
            id: 3
          },
          totalCount: {
            type: "uint32",
            id: 4
          }
        }
      },
      TSAdminExchangeLabelAddEditRequest: {
        fields: {
          StautsType: {
            type: "EditStautsEnum",
            id: 1
          },
          obj: {
            type: "LabelItem",
            id: 2
          }
        }
      },
      TSAdminExchangeLabelAddEditResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          labelList: {
            rule: "repeated",
            type: "LabelItem",
            id: 3
          }
        }
      },
      TSAdminExchangeLabelStatusRequest: {
        fields: {
          id: {
            type: "int32",
            id: 1
          },
          status: {
            type: "bool",
            id: 2
          }
        }
      },
      TSAdminExchangeLabelStatusResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSAdminProductCommentListRequest: {
        fields: {
          pid: {
            type: "string",
            id: 1
          },
          content: {
            type: "string",
            id: 2
          },
          pusherPhone: {
            type: "string",
            id: 3
          },
          title: {
            type: "string",
            id: 4
          },
          startTime: {
            type: "string",
            id: 5
          },
          endTime: {
            type: "string",
            id: 6
          },
          pageSize: {
            type: "int32",
            id: 7
          },
          pageNum: {
            type: "int32",
            id: 8
          }
        }
      },
      TSAdminProductCommentListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          commentList: {
            rule: "repeated",
            type: "CommentItem",
            id: 3
          },
          total: {
            type: "int32",
            id: 4
          }
        },
        nested: {
          CommentItem: {
            fields: {
              title: {
                type: "string",
                id: 1
              },
              pusherPhone: {
                type: "string",
                id: 2
              },
              content: {
                type: "string",
                id: 3
              },
              createTime: {
                type: "string",
                id: 4
              },
              pid: {
                type: "string",
                id: 5
              },
              commentId: {
                type: "string",
                id: 6
              }
            }
          }
        }
      },
      TSAdminProductVerifyCommentRequest: {
        fields: {
          commentId: {
            type: "string",
            id: 1
          },
          status: {
            type: "ProductCommentStatue",
            id: 2
          }
        }
      },
      TSAdminProductVerifyCommentResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSPoolListRequest: {
        fields: {
          poolName: {
            type: "string",
            id: 1
          },
          startTime: {
            type: "string",
            id: 2
          },
          endTime: {
            type: "string",
            id: 3
          },
          status: {
            type: "ProductPoolStatus",
            id: 4
          },
          remark: {
            type: "string",
            id: 5
          },
          pageSize: {
            type: "int32",
            id: 6
          },
          pageNum: {
            type: "int32",
            id: 7
          }
        }
      },
      TSPoolListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          total: {
            type: "int32",
            id: 3
          },
          poolList: {
            rule: "repeated",
            type: "PoolItem",
            id: 4
          }
        },
        nested: {
          PoolItem: {
            fields: {
              poolId: {
                type: "string",
                id: 1
              },
              poolName: {
                type: "string",
                id: 2
              },
              totalProduct: {
                type: "int32",
                id: 3
              },
              totalOnSale: {
                type: "int32",
                id: 4
              },
              remark: {
                type: "string",
                id: 5
              },
              createTime: {
                type: "string",
                id: 6
              },
              status: {
                type: "ProductPoolStatus",
                id: 7
              },
              btnList: {
                rule: "repeated",
                type: "ProductPoolBtn",
                id: 8
              }
            }
          }
        }
      },
      TSSavePoolRequest: {
        fields: {
          poolId: {
            type: "string",
            id: 1
          },
          poolName: {
            type: "string",
            id: 2
          },
          remark: {
            type: "string",
            id: 3
          }
        }
      },
      TSSavePoolResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSPoolDetailRequest: {
        fields: {
          poolId: {
            type: "string",
            id: 1
          }
        }
      },
      TSPoolDetailResponse: {
        fields: {
          poolId: {
            type: "string",
            id: 1
          },
          poolName: {
            type: "string",
            id: 2
          },
          totalProduct: {
            type: "int32",
            id: 3
          },
          totalOnSale: {
            type: "int32",
            id: 4
          },
          remark: {
            type: "string",
            id: 5
          },
          createTime: {
            type: "string",
            id: 6
          },
          status: {
            type: "ProductPoolStatus",
            id: 7
          },
          btnList: {
            rule: "repeated",
            type: "ProductPoolBtn",
            id: 8
          },
          errorCode: {
            type: "int32",
            id: 9
          },
          errorMsg: {
            type: "string",
            id: 10
          }
        }
      },
      TSRemarkPoolRequest: {
        fields: {
          poolId: {
            type: "string",
            id: 1
          },
          remark: {
            type: "string",
            id: 2
          }
        }
      },
      TSRemarkPoolResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSEnablePoolRequest: {
        fields: {
          poolId: {
            type: "string",
            id: 1
          },
          enable: {
            type: "bool",
            id: 2
          }
        }
      },
      TSEnablePoolResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSPoolItemListRequest: {
        fields: {
          poolId: {
            type: "string",
            id: 1
          },
          title: {
            type: "string",
            id: 2
          },
          pid: {
            type: "string",
            id: 3
          },
          kindId: {
            type: "int32",
            id: 4
          },
          brandId: {
            type: "int32",
            id: 5
          },
          status: {
            type: "PsProductStatusEnum",
            id: 6
          },
          pageNum: {
            type: "int32",
            id: 7
          },
          pageSize: {
            type: "int32",
            id: 8
          }
        }
      },
      TSPoolItemListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          total: {
            type: "int32",
            id: 3
          },
          ProductList: {
            rule: "repeated",
            type: "ProductItem",
            id: 4
          }
        },
        nested: {
          ProductItem: {
            fields: {
              pid: {
                type: "string",
                id: 1
              },
              sku: {
                type: "string",
                id: 2
              },
              title: {
                type: "string",
                id: 3
              },
              appearancePic: {
                type: "string",
                id: 4
              },
              kindName: {
                type: "string",
                id: 5
              },
              brandName: {
                type: "string",
                id: 6
              },
              sellerPhone: {
                type: "string",
                id: 7
              },
              price: {
                type: "int32",
                id: 8
              },
              canSell: {
                type: "bool",
                id: 9
              },
              canExchange: {
                type: "bool",
                id: 10
              },
              indexNum: {
                type: "int32",
                id: 11
              },
              operator: {
                type: "string",
                id: 12
              },
              productType: {
                type: "PsProductTypeEnum",
                id: 13
              }
            }
          }
        }
      },
      TSPoolAddItemRequest: {
        fields: {
          poolId: {
            type: "string",
            id: 1
          },
          pids: {
            type: "string",
            id: 2
          },
          count: {
            type: "int32",
            id: 3
          }
        }
      },
      TSPoolAddItemResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSPoolDelItemRequest: {
        fields: {
          poolId: {
            type: "string",
            id: 1
          },
          pid: {
            type: "string",
            id: 2
          }
        }
      },
      TSPoolDelItemResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSPoolSortItemRequest: {
        fields: {
          poolId: {
            type: "string",
            id: 1
          },
          pid: {
            type: "string",
            id: 2
          },
          index: {
            type: "int32",
            id: 3
          }
        }
      },
      TSPoolSortItemResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSGetOpenScreenAdRequest: {
        fields: {}
      },
      TSGetOpenScreenAdResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          screenAd: {
            type: "ScreenAdInfo",
            id: 3
          }
        },
        nested: {
          ScreenAdInfo: {
            fields: {
              serialId: {
                type: "string",
                id: 1
              },
              type: {
                type: "OpenScreenAdType",
                id: 2
              },
              video: {
                type: "string",
                id: 3
              },
              cover: {
                type: "string",
                id: 4
              },
              linkType: {
                type: "OpenScreenAdLinkType",
                id: 5
              },
              appInfo: {
                type: "string",
                id: 6
              },
              link: {
                type: "string",
                id: 7
              }
            }
          }
        }
      },
      TSGetBomberAdRequest: {
        fields: {
          deviceId: {
            type: "string",
            id: 1
          },
          popPage: {
            type: "string",
            id: 2
          }
        }
      },
      TSGetBomberAdResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          bomberAd: {
            type: "BomberAdInfo",
            id: 3
          }
        },
        nested: {
          BomberAdInfo: {
            fields: {
              serialId: {
                type: "string",
                id: 1
              },
              title: {
                type: "string",
                id: 2
              },
              popUpPage: {
                type: "string",
                id: 3
              },
              triggerEvent: {
                type: "TriggerEventType",
                id: 4
              },
              readPageTime: {
                type: "int32",
                id: 5
              },
              linkType: {
                type: "OpenScreenAdLinkType",
                id: 6
              },
              appInfo: {
                type: "string",
                id: 7
              },
              link: {
                type: "string",
                id: 8
              }
            }
          }
        }
      },
      TSStatistisClickLinkRequest: {
        fields: {
          serialId: {
            type: "string",
            id: 1
          }
        }
      },
      TSStatistisClickLinkResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      UserInfos: {
        fields: {
          nickname: {
            type: "string",
            id: 1
          },
          birthday: {
            type: "string",
            id: 2
          },
          sex: {
            type: "int32",
            id: 3
          },
          avator: {
            type: "string",
            id: 4
          },
          userId: {
            type: "int32",
            id: 5
          }
        }
      },
      UserCountInfo: {
        fields: {
          myPublishProductCount: {
            type: "int32",
            id: 1
          },
          myLikeProductCount: {
            type: "int32",
            id: 2
          },
          myBuyCount: {
            type: "int32",
            id: 3
          },
          mySoldCount: {
            type: "int32",
            id: 4
          },
          shoppingNob: {
            type: "int32",
            id: 5
          }
        }
      },
      MineSendSMSCodeRequest: {
        fields: {
          phone: {
            type: "string",
            id: 1
          }
        }
      },
      MineSendSMSCodeResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      MineAccountInfoRequest: {
        fields: {}
      },
      MineAccountInfoResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          userInfo: {
            type: "UserInfos",
            id: 3
          },
          userCountInfo: {
            type: "UserCountInfo",
            id: 4
          },
          totalAssets: {
            type: "int32",
            id: 5
          }
        }
      },
      MineAccountEditRequest: {
        fields: {
          nickname: {
            type: "string",
            id: 1
          },
          birthday: {
            type: "string",
            id: 2
          },
          sex: {
            type: "int32",
            id: 3
          },
          avator: {
            type: "string",
            id: 4
          }
        }
      },
      MineAccountEditResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      BaseSimpleProductDetail: {
        fields: {
          productName: {
            type: "string",
            id: 1
          },
          brandName: {
            type: "string",
            id: 2
          },
          price: {
            type: "int32",
            id: 3
          },
          newsName: {
            type: "string",
            id: 4
          },
          mainImageUrl: {
            type: "string",
            id: 5
          },
          pid: {
            type: "string",
            id: 6
          },
          isSell: {
            type: "bool",
            id: 7
          },
          isExchange: {
            type: "bool",
            id: 8
          },
          expired: {
            type: "bool",
            id: 9
          }
        }
      },
      StructructedProductDetail: {
        fields: {
          productInfo: {
            type: "BaseSimpleProductDetail",
            id: 1
          },
          isLike: {
            type: "bool",
            id: 2
          },
          likeCount: {
            type: "int32",
            id: 3
          },
          userName: {
            type: "string",
            id: 4
          },
          userAvator: {
            type: "string",
            id: 5
          }
        }
      },
      MineLikeProductListRequest: {
        fields: {
          pageNum: {
            type: "int32",
            id: 1
          },
          pageSize: {
            type: "int32",
            id: 2
          }
        }
      },
      MineLikeProductListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          productList: {
            rule: "repeated",
            type: "StructructedProductDetail",
            id: 3
          },
          isEnd: {
            type: "bool",
            id: 4
          }
        }
      },
      WantItemUserInfo: {
        fields: {
          avatar: {
            type: "string",
            id: 1
          },
          nickName: {
            type: "string",
            id: 2
          },
          exchangeOutCount: {
            type: "int32",
            id: 3
          },
          publishCount: {
            type: "int32",
            id: 4
          },
          isAttention: {
            type: "bool",
            id: 5
          },
          userId: {
            type: "string",
            id: 6
          }
        }
      },
      MineWantMeExchangeListRequest: {
        fields: {
          pageNum: {
            type: "int32",
            id: 1
          },
          pageSize: {
            type: "int32",
            id: 2
          }
        }
      },
      MineWantMeExchangeListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          dataList: {
            rule: "repeated",
            type: "WantMeExchangeItem",
            id: 3
          },
          isEnd: {
            type: "bool",
            id: 4
          }
        },
        nested: {
          WantMeExchangeItem: {
            fields: {
              id: {
                type: "string",
                id: 1
              },
              userInfo: {
                type: "WantItemUserInfo",
                id: 2
              },
              productInfo: {
                type: "BaseSimpleProductDetail",
                id: 3
              },
              isLikeProduct: {
                type: "bool",
                id: 4
              },
              productLikeCount: {
                type: "int32",
                id: 5
              },
              status: {
                type: "int32",
                id: 6
              }
            }
          }
        }
      },
      MineWantMeExchangeDealRequest: {
        fields: {
          id: {
            type: "string",
            id: 1
          }
        }
      },
      MineWantMeExchangeDealResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      MineWantExchangeListRequest: {
        fields: {
          pageNum: {
            type: "int32",
            id: 1
          },
          pageSize: {
            type: "int32",
            id: 2
          }
        }
      },
      MineWantExchangeListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          dataList: {
            rule: "repeated",
            type: "WantExchangeItem",
            id: 3
          },
          isEnd: {
            type: "bool",
            id: 4
          }
        },
        nested: {
          WantExchangeItem: {
            fields: {
              id: {
                type: "string",
                id: 1
              },
              userInfo: {
                type: "WantItemUserInfo",
                id: 2
              },
              productInfo: {
                type: "BaseSimpleProductDetail",
                id: 3
              },
              isLikeProduct: {
                type: "bool",
                id: 4
              },
              productLikeCount: {
                type: "int32",
                id: 5
              }
            }
          }
        }
      },
      TSBuyerQueryOrderListRequest: {
        fields: {
          pageNum: {
            type: "int32",
            id: 1
          },
          pageSize: {
            type: "int32",
            id: 2
          },
          buyerOrderState: {
            type: "BuyerOrderStateEnum",
            id: 3
          },
          pageType: {
            type: "PsProductPageTypeEnum",
            id: 4
          }
        }
      },
      TSBuyerQueryOrderListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          orderInfos: {
            rule: "repeated",
            type: "MallBuyerBriefOrderInfo",
            id: 3
          },
          isEnd: {
            type: "bool",
            id: 4
          }
        }
      },
      TSMallBuyerOrderDetailRequest: {
        fields: {
          orderNo: {
            type: "string",
            id: 1
          },
          pageType: {
            type: "PsProductPageTypeEnum",
            id: 2
          }
        }
      },
      TSMallBuyerOrderDetaiResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          orderDetailInfo: {
            type: "MallBuyerBriefOrderInfo",
            id: 3
          },
          warehouseAddress: {
            type: "PsUserAddress",
            id: 4
          }
        }
      },
      TSMallOrderBuyerGenOrderRequest: {
        fields: {
          pid: {
            type: "string",
            id: 1
          },
          addrId: {
            type: "string",
            id: 2
          },
          sku: {
            type: "string",
            id: 3
          },
          buyNum: {
            type: "int32",
            id: 4
          },
          pageType: {
            type: "PsProductPageTypeEnum",
            id: 5
          }
        }
      },
      TSMallOrderBuyerGenOrderResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          orderNo: {
            type: "string",
            id: 3
          },
          CashierId: {
            type: "string",
            id: 4
          }
        }
      },
      TSMallBuyerOrderPageRequest: {
        fields: {
          pid: {
            type: "string",
            id: 1
          },
          addrId: {
            type: "string",
            id: 2
          },
          sku: {
            type: "string",
            id: 3
          },
          buyNum: {
            type: "int32",
            id: 4
          },
          pageType: {
            type: "PsProductPageTypeEnum",
            id: 5
          }
        }
      },
      TSMallBuyerOrderPageResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          productItem: {
            type: "PsProductItem",
            id: 3
          },
          expressFee: {
            type: "int32",
            id: 4
          },
          payAmount: {
            type: "int32",
            id: 5
          },
          transferFee: {
            type: "int32",
            id: 6
          },
          transferFeePercent: {
            type: "int32",
            id: 7
          }
        }
      },
      TSMallBuyerOrderPayRequest: {
        fields: {
          orderNo: {
            type: "string",
            id: 1
          },
          payType: {
            type: "PaymentType",
            id: 2
          },
          openid: {
            type: "string",
            id: 3
          }
        }
      },
      TSMallBuyerOrderPayResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          "package": {
            type: "string",
            id: 3
          },
          nonceStr: {
            type: "string",
            id: 4
          },
          timestamp: {
            type: "string",
            id: 5
          },
          paySign: {
            type: "string",
            id: 6
          },
          signType: {
            type: "string",
            id: 7
          }
        }
      },
      TSMallBuyerAppPayRequest: {
        fields: {
          orderNo: {
            type: "string",
            id: 1
          },
          payType: {
            type: "PaymentType",
            id: 2
          }
        }
      },
      TSMallBuyerAppPayResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          aliOrderInfo: {
            type: "string",
            id: 3
          },
          wechatOrderInfo: {
            type: "wechatObj",
            id: 4
          }
        },
        nested: {
          wechatObj: {
            fields: {
              appid: {
                type: "string",
                id: 1
              },
              noncestr: {
                type: "string",
                id: 2
              },
              "package": {
                type: "string",
                id: 3
              },
              partnerid: {
                type: "string",
                id: 4
              },
              prepayid: {
                type: "string",
                id: 5
              },
              timestamp: {
                type: "string",
                id: 6
              },
              sign: {
                type: "string",
                id: 7
              }
            }
          }
        }
      },
      TSMallBuyerPublicPayRequest: {
        fields: {
          orderNo: {
            type: "string",
            id: 1
          }
        }
      },
      TSMallBuyerPublicPayResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSMallAliPayRequest: {
        fields: {
          orderNo: {
            type: "string",
            id: 1
          }
        }
      },
      TSMallAliPayResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          paySign: {
            type: "string",
            id: 3
          },
          signType: {
            type: "string",
            id: 4
          },
          appId: {
            type: "string",
            id: 5
          },
          "package": {
            type: "string",
            id: 6
          },
          nonceStr: {
            type: "string",
            id: 7
          },
          timestamp: {
            type: "string",
            id: 8
          }
        }
      },
      TSMallQueryOrderStateRequest: {
        fields: {
          orderNo: {
            type: "string",
            id: 1
          }
        }
      },
      TSMallQueryOrderStateResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          success: {
            type: "bool",
            id: 3
          }
        }
      },
      TSMallBuyerCancelOrderRequest: {
        fields: {
          orderNo: {
            type: "string",
            id: 1
          }
        }
      },
      TSMallBuyerCancelOrderResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSMallBuyerModifyAddrRequest: {
        fields: {
          orderNo: {
            type: "string",
            id: 1
          },
          addrId: {
            type: "string",
            id: 2
          }
        }
      },
      TSMallBuyerModifyAddrResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSMallOrderBuyerExpressRequest: {
        fields: {
          orderNo: {
            type: "string",
            id: 1
          }
        }
      },
      TSMallOrderBuyerExpressResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          expressItems: {
            rule: "repeated",
            type: "PsExpressItem",
            id: 3
          },
          expressFlowItem: {
            rule: "repeated",
            type: "ExpressFlowItem",
            id: 4
          }
        }
      },
      TSMallOrderBuyerReceiveRequest: {
        fields: {
          orderNo: {
            type: "string",
            id: 1
          }
        }
      },
      TSMallOrderBuyerReceiveResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSMallOrderBuyerDelRequest: {
        fields: {
          orderNo: {
            type: "string",
            id: 1
          }
        }
      },
      TSMallOrderBuyerDelResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSMallSellerSellListRequest: {
        fields: {
          pageNum: {
            type: "int32",
            id: 1
          },
          pageSize: {
            type: "int32",
            id: 2
          },
          orderStatus: {
            type: "SellerOrderStateEnum",
            id: 3
          }
        }
      },
      TSMallSellerSellListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          briefOrderInfo: {
            rule: "repeated",
            type: "MallBuyerBriefOrderInfo",
            id: 3
          },
          isEnd: {
            type: "bool",
            id: 4
          }
        }
      },
      TSMallSellerOrderDetailRequest: {
        fields: {
          orderNo: {
            type: "string",
            id: 1
          }
        }
      },
      TSMallSellerOrderDetaiResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          orderDetailInfo: {
            type: "MallSellerBriefOrderInfo",
            id: 3
          },
          warehouseAddress: {
            type: "PsUserAddress",
            id: 4
          }
        }
      },
      TSMallOrderSellerDeliverRequest: {
        fields: {
          orderNo: {
            type: "string",
            id: 1
          },
          expressNumber: {
            type: "string",
            id: 2
          },
          backAddressId: {
            type: "string",
            id: 3
          }
        }
      },
      TSMallOrderSellerDeliverResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSMallSellerCancelOrderRequest: {
        fields: {
          orderNo: {
            type: "string",
            id: 1
          }
        }
      },
      TSMallSellerCancelOrderResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSMallSellerModifyAddrRequest: {
        fields: {
          orderNo: {
            type: "string",
            id: 1
          },
          addrId: {
            type: "string",
            id: 2
          }
        }
      },
      TSMallSellerModifyAddrResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSMallOrderSellerDelRequest: {
        fields: {
          orderNo: {
            type: "string",
            id: 1
          }
        }
      },
      TSMallOrderSellerDelResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSMallOrderSellerExpressRequest: {
        fields: {
          orderNo: {
            type: "string",
            id: 1
          }
        }
      },
      TSMallSellerExpressResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          expressItems: {
            rule: "repeated",
            type: "PsExpressItem",
            id: 3
          },
          expressFlowItem: {
            rule: "repeated",
            type: "ExpressFlowItem",
            id: 4
          }
        }
      },
      TSMallOrderPayBrowserRequest: {
        fields: {
          orderNo: {
            type: "string",
            id: 1
          },
          payType: {
            type: "PaymentType",
            id: 2
          },
          quitUrl: {
            type: "string",
            id: 3
          }
        }
      },
      TSMallOrderPayBrowserResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          payUrl: {
            type: "string",
            id: 3
          }
        }
      },
      TSMallOrderPayWxBrowserRequest: {
        fields: {
          orderNo: {
            type: "string",
            id: 1
          },
          openid: {
            type: "string",
            id: 2
          }
        }
      },
      TSMallOrderPayWxBrowserResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          paySign: {
            type: "string",
            id: 3
          },
          signType: {
            type: "string",
            id: 4
          },
          appId: {
            type: "string",
            id: 5
          },
          "package": {
            type: "string",
            id: 6
          },
          nonceStr: {
            type: "string",
            id: 7
          },
          timestamp: {
            type: "string",
            id: 8
          }
        }
      },
      PageIndexEnum: {
        values: {
          INDEX_init: 0,
          INDEX_Own: 1,
          INDEX_Other: 2
        }
      },
      ParentMatchOrderStatusEnum: {
        values: {
          MO_Default: 0,
          MO_Paid: 1,
          MO_Succeed: 2,
          MO_Failed: 3
        }
      },
      PaidModeEnum: {
        values: {
          PAID_init: 0,
          PAID_Alipay: 1,
          PAID_WeChat: 2,
          PAID_UnionPay: 3
        }
      },
      OrderProductInfo: {
        fields: {
          pid: {
            type: "string",
            id: 1
          },
          productName: {
            type: "string",
            id: 2
          },
          sku: {
            type: "string",
            id: 3
          },
          appearancePic: {
            type: "string",
            id: 4
          },
          content: {
            type: "string",
            id: 5
          },
          brandName: {
            type: "string",
            id: 6
          },
          imgList: {
            rule: "repeated",
            type: "string",
            id: 7
          },
          newsName: {
            type: "string",
            id: 8
          },
          price: {
            type: "int32",
            id: 9
          },
          likeCount: {
            type: "int32",
            id: 10
          },
          describtion: {
            type: "string",
            id: 11
          },
          skuBasic: {
            type: "Basic",
            id: 12
          },
          isExchange: {
            type: "bool",
            id: 13
          },
          officialPrice: {
            type: "int32",
            id: 14
          }
        },
        nested: {
          Basic: {
            fields: {
              sku: {
                type: "string",
                id: 1
              },
              brandName: {
                type: "string",
                id: 2
              },
              kindName: {
                type: "string",
                id: 3
              },
              measurement: {
                type: "string",
                id: 4
              },
              mainPic: {
                type: "string",
                id: 5
              },
              color: {
                type: "string",
                id: 6
              },
              size: {
                type: "string",
                id: 7
              },
              seriesName: {
                type: "string",
                id: 8
              },
              productName: {
                type: "string",
                id: 9
              }
            }
          }
        }
      },
      ExchangeOrderInfo: {
        fields: {
          orderNo: {
            type: "string",
            id: 1
          },
          status: {
            type: "CExchangeOrderStatus",
            id: 2
          },
          button: {
            rule: "repeated",
            type: "ExchangeButton",
            id: 3
          },
          expressFee: {
            type: "int32",
            id: 4
          },
          transferFee: {
            type: "int32",
            id: 5
          },
          productInfo: {
            type: "OrderProductInfo",
            id: 6
          },
          failReason: {
            type: "string",
            id: 7
          },
          statusName: {
            type: "string",
            id: 8
          }
        }
      },
      MatchOrderUserInfo: {
        fields: {
          avatar: {
            type: "string",
            id: 1
          },
          nickName: {
            type: "string",
            id: 2
          },
          exchangeOutCount: {
            type: "int32",
            id: 3
          },
          publishCount: {
            type: "int32",
            id: 4
          },
          isAttention: {
            type: "bool",
            id: 5
          },
          userId: {
            type: "int32",
            id: 6
          },
          address: {
            type: "string",
            id: 7
          }
        }
      },
      MatchOrderInfo: {
        fields: {
          orderNo: {
            type: "string",
            id: 1
          },
          matchStatus: {
            type: "MatchStatusEnum",
            id: 2
          },
          button: {
            rule: "repeated",
            type: "MatchButton",
            id: 3
          },
          productInfo: {
            type: "OrderProductInfo",
            id: 4
          },
          expressFee: {
            type: "int32",
            id: 5
          },
          transferFee: {
            type: "int32",
            id: 6
          },
          waitPayAmount: {
            type: "int32",
            id: 7
          },
          diffFee: {
            type: "int32",
            id: 8
          },
          payStatus: {
            type: "bool",
            id: 9
          },
          failReason: {
            type: "string",
            id: 10
          },
          matchStatusName: {
            type: "string",
            id: 11
          },
          productUserInfo: {
            type: "MatchOrderUserInfo",
            id: 12
          },
          refundAlert: {
            type: "string",
            id: 13
          },
          isProductValid: {
            type: "bool",
            id: 14
          },
          JumpPage: {
            type: "JumpDetailPageEnum",
            id: 15
          },
          createTime: {
            type: "string",
            id: 16
          },
          payType: {
            type: "PaymentType",
            id: 17
          }
        },
        nested: {
          JumpDetailPageEnum: {
            values: {
              JumpInit: 0,
              WaitToPay: 1,
              Paid: 2,
              ExchangeOrder: 3
            }
          }
        }
      },
      MatchOrderItem: {
        fields: {
          parentOrderId: {
            type: "string",
            id: 1
          },
          buyOrder: {
            type: "MatchOrderInfo",
            id: 2
          },
          sellOrder: {
            type: "MatchOrderInfo",
            id: 3
          },
          parentStatusName: {
            type: "string",
            id: 4
          },
          parentMatchOrderStatus: {
            type: "ParentMatchOrderStatusEnum",
            id: 5
          },
          payTimeLeft: {
            type: "int32",
            id: 6
          },
          isValid: {
            type: "bool",
            id: 7
          },
          validReason: {
            type: "string",
            id: 8
          }
        }
      },
      TSSearchMatchPdtNbRequest: {
        fields: {}
      },
      TSSearchMatchPdtNbResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          totalCount: {
            type: "int32",
            id: 3
          },
          buyOrder: {
            rule: "repeated",
            type: "MatchOrderInfo",
            id: 4
          }
        }
      },
      TSSearchDiffPriceRequest: {
        fields: {
          myPid: {
            type: "string",
            id: 1
          },
          otherPid: {
            type: "string",
            id: 2
          }
        }
      },
      TSSearchDiffPriceResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          diffPrice: {
            type: "int32",
            id: 3
          }
        }
      },
      TSOtherExchangeProductListRequest: {
        fields: {
          pageNum: {
            type: "int32",
            id: 1
          },
          pageSize: {
            type: "int32",
            id: 2
          },
          pid: {
            type: "string",
            id: 3
          }
        }
      },
      TSOtherExchangeProductListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          otherProductList: {
            rule: "repeated",
            type: "OrderProductInfo",
            id: 3
          },
          isEnd: {
            type: "bool",
            id: 4
          }
        }
      },
      TSMyExchangeProductRequest: {
        fields: {}
      },
      TSMyExchangeProductResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          myProductList: {
            rule: "repeated",
            type: "OrderProductInfo",
            id: 3
          }
        }
      },
      TSCreateMatchOrderRequest: {
        fields: {
          myPid: {
            type: "string",
            id: 1
          },
          otherPid: {
            type: "string",
            id: 2
          },
          platform: {
            type: "PlatformEnum",
            id: 3
          }
        }
      },
      TSCreateMatchOrderResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSMatchOrderDetailRequest: {
        fields: {
          orderNo: {
            type: "string",
            id: 1
          }
        }
      },
      TSMatchOrderDetailResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          matchOrderDetail: {
            type: "MatchOrderItem",
            id: 3
          }
        }
      },
      TSMatchOrderPayDetailRequest: {
        fields: {
          orderNo: {
            type: "string",
            id: 1
          }
        }
      },
      TSMatchOrderPayDetailResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          status: {
            type: "MatchStatusEnum",
            id: 3
          },
          statusName: {
            type: "string",
            id: 4
          },
          statusDesc: {
            type: "string",
            id: 5
          },
          buyOrder: {
            type: "Order",
            id: 6
          },
          sellOrder: {
            type: "Order",
            id: 7
          }
        },
        nested: {
          Product: {
            fields: {
              appearancePic: {
                type: "string",
                id: 1
              },
              newsName: {
                type: "string",
                id: 2
              },
              productName: {
                type: "string",
                id: 3
              },
              price: {
                type: "int32",
                id: 4
              }
            }
          },
          Order: {
            fields: {
              orderNo: {
                type: "string",
                id: 1
              },
              product: {
                type: "Product",
                id: 2
              },
              transferFee: {
                type: "int32",
                id: 3
              },
              expressFee: {
                type: "int32",
                id: 4
              },
              diffPrice: {
                type: "int32",
                id: 5
              },
              transferFeePercent: {
                type: "int32",
                id: 6
              },
              totalAmount: {
                type: "int32",
                id: 7
              },
              needPay: {
                type: "bool",
                id: 8
              }
            }
          }
        }
      },
      TSMatchOrderConfirmRequest: {
        fields: {
          orderNo: {
            type: "string",
            id: 1
          },
          address: {
            type: "string",
            id: 2
          }
        }
      },
      TSMatchOrderConfirmResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSMatchOrderPayRequest: {
        fields: {
          orderNo: {
            type: "string",
            id: 1
          },
          payType: {
            type: "PaymentType",
            id: 2
          },
          address: {
            type: "string",
            id: 3
          }
        }
      },
      TSMatchOrderPayResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          aliOrderInfo: {
            type: "string",
            id: 3
          },
          weChatInfo: {
            type: "WeChatInfo",
            id: 4
          }
        },
        nested: {
          WeChatInfo: {
            fields: {
              appid: {
                type: "string",
                id: 1
              },
              noncestr: {
                type: "string",
                id: 2
              },
              "package": {
                type: "string",
                id: 3
              },
              partnerid: {
                type: "string",
                id: 4
              },
              prepayid: {
                type: "string",
                id: 5
              },
              timestamp: {
                type: "string",
                id: 6
              },
              sign: {
                type: "string",
                id: 7
              }
            }
          }
        }
      },
      TSExchangeProductListRequest: {
        fields: {
          pageIndex: {
            type: "PageIndexEnum",
            id: 1
          },
          pageNum: {
            type: "int32",
            id: 3
          },
          pageSize: {
            type: "int32",
            id: 4
          }
        }
      },
      TSExchangeProductListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          matchItemList: {
            rule: "repeated",
            type: "MatchOrderItem",
            id: 3
          },
          isEnd: {
            type: "bool",
            id: 4
          }
        }
      },
      TSDelExchangeProductRequest: {
        fields: {
          pageIndex: {
            type: "PageIndexEnum",
            id: 1
          },
          parentOrderId: {
            type: "string",
            id: 2
          }
        }
      },
      TSDelExchangeProductResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSQueryCancelExchangeOrderRequest: {
        fields: {}
      },
      TSQueryCancelExchangeOrderResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          matchItemList: {
            type: "MatchOrderItem",
            id: 3
          }
        }
      },
      TSMatchingOrderListRequest: {
        fields: {
          pageNum: {
            type: "int32",
            id: 3
          },
          pageSize: {
            type: "int32",
            id: 4
          }
        }
      },
      TSMatchingOrderListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          matchItemList: {
            rule: "repeated",
            type: "MatchOrderItem",
            id: 3
          },
          isEnd: {
            type: "bool",
            id: 4
          }
        }
      },
      TSMatchProductStatusRequest: {
        fields: {
          type: {
            type: "MatchButtonType",
            id: 1
          },
          buyOrderNo: {
            type: "string",
            id: 2
          },
          sellOrderNo: {
            type: "string",
            id: 3
          }
        }
      },
      TSMatchProductStatusResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSMatchOrderListRequest: {
        fields: {
          pageNum: {
            type: "int32",
            id: 1
          },
          pageSize: {
            type: "int32",
            id: 2
          }
        }
      },
      TSMatchOrderListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          matchOrderList: {
            rule: "repeated",
            type: "MatchOrderItem",
            id: 3
          },
          isEnd: {
            type: "bool",
            id: 4
          }
        }
      },
      ExchangeOrderItem: {
        fields: {
          parentOrderId: {
            type: "string",
            id: 1
          },
          buyOrder: {
            type: "ExchangeOrderInfo",
            id: 2
          },
          sellOrder: {
            type: "ExchangeOrderInfo",
            id: 3
          },
          parentStatusName: {
            type: "string",
            id: 4
          },
          status: {
            type: "PExchangeOrderStatus",
            id: 5
          },
          refundAlert: {
            type: "string",
            id: 6
          }
        }
      },
      TSExchangeOrderListRequest: {
        fields: {
          pageNum: {
            type: "int32",
            id: 1
          },
          pageSize: {
            type: "int32",
            id: 2
          },
          status: {
            type: "Status",
            id: 3
          }
        },
        nested: {
          Status: {
            values: {
              ExchangingDefault: 0,
              Exchanging: 1,
              ExchangeSuccess: 2,
              ExchangeFail: 3
            }
          }
        }
      },
      TSExchangeOrderListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          exchangeOrderList: {
            rule: "repeated",
            type: "ExchangeOrderItem",
            id: 3
          },
          isEnd: {
            type: "bool",
            id: 4
          }
        }
      },
      TSExchangeOrderDeliverRequest: {
        fields: {
          orderNo: {
            type: "string",
            id: 1
          },
          expressNumber: {
            type: "string",
            id: 2
          },
          backAddressId: {
            type: "string",
            id: 3
          }
        }
      },
      TSExchangeOrderDeliverResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSExchangeOrderReceiveRequest: {
        fields: {
          orderNo: {
            type: "string",
            id: 1
          }
        }
      },
      TSExchangeOrderReceiveResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSExchangeOrderDetailRequest: {
        fields: {
          orderNo: {
            type: "string",
            id: 1
          }
        }
      },
      TSExchangeOrderDetailResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          status: {
            type: "PExchangeOrderStatus",
            id: 3
          },
          statusName: {
            type: "string",
            id: 4
          },
          statusDesc: {
            type: "string",
            id: 5
          },
          buyOrder: {
            type: "OrderDetail",
            id: 6
          },
          sellOrder: {
            type: "OrderDetail",
            id: 7
          },
          refundAlert: {
            type: "string",
            id: 8
          }
        },
        nested: {
          OrderDetail: {
            fields: {
              orderNo: {
                type: "string",
                id: 1
              },
              status: {
                type: "CExchangeOrderStatus",
                id: 2
              },
              button: {
                rule: "repeated",
                type: "ExchangeButton",
                id: 3
              },
              expressFee: {
                type: "int32",
                id: 4
              },
              transferFee: {
                type: "int32",
                id: 5
              },
              productInfo: {
                type: "OrderProductInfo",
                id: 6
              },
              failReason: {
                type: "string",
                id: 7
              },
              diffPrice: {
                type: "int32",
                id: 8
              },
              address: {
                type: "PsUserAddress",
                id: 9
              },
              createTime: {
                type: "string",
                id: 10
              },
              payType: {
                type: "PaymentType",
                id: 11
              },
              transferFeeRate: {
                type: "int32",
                id: 12
              }
            }
          }
        }
      },
      ProductInfo: {
        fields: {
          price: {
            type: "int32",
            id: 1
          },
          newsName: {
            type: "string",
            id: 2
          },
          brandEnName: {
            type: "string",
            id: 3
          },
          productName: {
            type: "string",
            id: 4
          },
          title: {
            type: "string",
            id: 5
          },
          description: {
            type: "string",
            id: 6
          }
        }
      },
      TSAppraisalPointsRequest: {
        fields: {
          brandId: {
            type: "int32",
            id: 1
          }
        }
      },
      TSAppraisalPointsResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          imageInfo: {
            rule: "repeated",
            type: "ScImageInfo",
            id: 3
          }
        }
      },
      TSProductPrescreeningRequest: {
        fields: {
          KindId: {
            type: "int32",
            id: 1
          },
          sku: {
            type: "string",
            id: 2
          },
          imgList: {
            rule: "repeated",
            type: "ScImageInfo",
            id: 3
          }
        }
      },
      TSProductPrescreeningResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          screenningId: {
            type: "string",
            id: 3
          },
          newsId: {
            type: "int32",
            id: 4
          },
          newsName: {
            type: "string",
            id: 5
          },
          minPrice: {
            type: "int32",
            id: 6
          },
          maxPrice: {
            type: "int32",
            id: 7
          }
        }
      },
      TSProductAddRequest: {
        fields: {
          sku: {
            type: "string",
            id: 1
          },
          sendWord: {
            type: "string",
            id: 2
          },
          imgList: {
            rule: "repeated",
            type: "ScImageInfo",
            id: 3
          },
          newsId: {
            type: "int32",
            id: 4
          },
          price: {
            type: "int32",
            id: 5
          },
          tagIds: {
            rule: "repeated",
            type: "string",
            id: 6
          },
          exchangeable: {
            type: "bool",
            id: 7
          },
          saleable: {
            type: "bool",
            id: 8
          },
          shareable: {
            type: "bool",
            id: 9
          },
          title: {
            type: "string",
            id: 10
          },
          pid: {
            type: "string",
            id: 11
          },
          screenningId: {
            type: "string",
            id: 12
          }
        }
      },
      TSProductAddResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          pid: {
            type: "string",
            id: 3
          }
        }
      },
      TSShareProductAddRequest: {
        fields: {
          title: {
            type: "string",
            id: 1
          },
          sendWord: {
            type: "string",
            id: 2
          },
          imgList: {
            rule: "repeated",
            type: "ScImageInfo",
            id: 3
          },
          price: {
            type: "int32",
            id: 4
          },
          tagIds: {
            rule: "repeated",
            type: "string",
            id: 5
          }
        }
      },
      TSShareProductAddResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          pid: {
            type: "string",
            id: 3
          }
        }
      },
      TSProductAiNewRequest: {
        fields: {
          imgList: {
            rule: "repeated",
            type: "ScImageInfo",
            id: 1
          },
          KindId: {
            type: "int32",
            id: 2
          }
        }
      },
      TSProductAiNewResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          newsId: {
            type: "int32",
            id: 3
          },
          newsName: {
            type: "string",
            id: 4
          }
        }
      },
      TSProductEvaluateRequest: {
        fields: {
          newId: {
            type: "int32",
            id: 1
          },
          sku: {
            type: "string",
            id: 2
          }
        }
      },
      TSProductEvaluateResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          minPrice: {
            type: "int32",
            id: 3
          },
          maxPrice: {
            type: "int32",
            id: 4
          }
        }
      },
      TSProductDetailRequest: {
        fields: {
          pid: {
            type: "string",
            id: 1
          }
        }
      },
      TSProductDetailResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          userInfo: {
            type: "UserInfo",
            id: 3
          },
          product: {
            type: "ScProductDTO",
            id: 4
          }
        }
      },
      TSProductDelRequest: {
        fields: {
          pid: {
            type: "string",
            id: 1
          }
        }
      },
      TSProductDelResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSProductUpDownRequest: {
        fields: {
          pid: {
            type: "string",
            id: 1
          },
          down: {
            type: "bool",
            id: 2
          }
        }
      },
      TSProductUpDownResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSMallProductListRequest: {
        fields: {
          pageNum: {
            type: "int32",
            id: 1
          },
          pageSize: {
            type: "int32",
            id: 2
          },
          status: {
            type: "PsProductStatusEnum",
            id: 3
          }
        }
      },
      TSMallProductListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          productList: {
            rule: "repeated",
            type: "Product",
            id: 3
          },
          isEnd: {
            type: "bool",
            id: 4
          }
        },
        nested: {
          ButtonType: {
            values: {
              Init: 0,
              Edit: 1,
              Delete: 2,
              Up: 3,
              Down: 4
            }
          },
          Button: {
            fields: {
              type: {
                type: "ButtonType",
                id: 1
              },
              title: {
                type: "string",
                id: 2
              }
            }
          },
          Product: {
            fields: {
              newsName: {
                type: "string",
                id: 1
              },
              productName: {
                type: "string",
                id: 2
              },
              pid: {
                type: "string",
                id: 3
              },
              price: {
                type: "int32",
                id: 4
              },
              appearanceImgUrl: {
                type: "string",
                id: 5
              },
              brandName: {
                type: "string",
                id: 6
              },
              kindName: {
                type: "string",
                id: 7
              },
              measurement: {
                type: "string",
                id: 8
              },
              mainPic: {
                type: "string",
                id: 9
              },
              color: {
                type: "string",
                id: 10
              },
              status: {
                type: "PsProductStatusEnum",
                id: 11
              },
              statusName: {
                type: "string",
                id: 12
              },
              buttons: {
                rule: "repeated",
                type: "Button",
                id: 13
              }
            }
          }
        }
      },
      TSMinePublishProductListRequest: {
        fields: {
          pageNum: {
            type: "int32",
            id: 1
          },
          pageSize: {
            type: "int32",
            id: 2
          }
        }
      },
      TSMinePublishProductListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          productList: {
            rule: "repeated",
            type: "PsProductItem",
            id: 3
          },
          isEnd: {
            type: "bool",
            id: 4
          }
        }
      },
      TSProductInfoRequest: {
        fields: {
          pid: {
            type: "string",
            id: 1
          }
        }
      },
      TSProductInfoResponse: {
        fields: {
          sku: {
            type: "string",
            id: 1
          },
          sendWord: {
            type: "string",
            id: 2
          },
          imgList: {
            rule: "repeated",
            type: "ScImageInfo",
            id: 3
          },
          newsId: {
            type: "int32",
            id: 4
          },
          newsName: {
            type: "string",
            id: 5
          },
          price: {
            type: "int32",
            id: 6
          },
          tagIds: {
            rule: "repeated",
            type: "string",
            id: 7
          },
          exchangeable: {
            type: "bool",
            id: 8
          },
          saleable: {
            type: "bool",
            id: 9
          },
          shareable: {
            type: "bool",
            id: 10
          },
          title: {
            type: "string",
            id: 11
          },
          skuBasic: {
            type: "Basic",
            id: 12
          },
          errorCode: {
            type: "int32",
            id: 13
          },
          errorMsg: {
            type: "string",
            id: 14
          },
          brandName: {
            type: "string",
            id: 15
          },
          kindId: {
            type: "int32",
            id: 16
          },
          brandId: {
            type: "int32",
            id: 17
          },
          sendWordType: {
            type: "SendWordType",
            id: 18
          },
          sendwordList: {
            rule: "repeated",
            type: "SendWordItem",
            id: 19
          }
        },
        nested: {
          Basic: {
            fields: {
              sku: {
                type: "string",
                id: 1
              },
              brandName: {
                type: "string",
                id: 2
              },
              kindName: {
                type: "string",
                id: 3
              },
              measurement: {
                type: "string",
                id: 4
              },
              mainPic: {
                type: "string",
                id: 5
              },
              color: {
                type: "string",
                id: 6
              },
              size: {
                type: "string",
                id: 7
              },
              seriesName: {
                type: "string",
                id: 8
              },
              productName: {
                type: "string",
                id: 9
              }
            }
          }
        }
      },
      TSProductModifyRequest: {
        fields: {
          sku: {
            type: "string",
            id: 1
          },
          sendWord: {
            type: "string",
            id: 2
          },
          imgList: {
            rule: "repeated",
            type: "ScImageInfo",
            id: 3
          },
          newsId: {
            type: "int32",
            id: 4
          },
          price: {
            type: "int32",
            id: 5
          },
          tagIds: {
            rule: "repeated",
            type: "string",
            id: 6
          },
          exchangeable: {
            type: "bool",
            id: 7
          },
          saleable: {
            type: "bool",
            id: 8
          },
          shareable: {
            type: "bool",
            id: 9
          },
          title: {
            type: "string",
            id: 10
          },
          pid: {
            type: "string",
            id: 11
          },
          screenningId: {
            type: "string",
            id: 12
          }
        }
      },
      TSProductModifyResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSProductShareInfoRequest: {
        fields: {
          pid: {
            type: "string",
            id: 1
          }
        }
      },
      TSProductShareInfoResponse: {
        fields: {
          title: {
            type: "string",
            id: 1
          },
          sendWord: {
            type: "string",
            id: 2
          },
          imgList: {
            rule: "repeated",
            type: "ScImageInfo",
            id: 3
          },
          price: {
            type: "int32",
            id: 4
          },
          tagIds: {
            rule: "repeated",
            type: "string",
            id: 5
          },
          errorCode: {
            type: "int32",
            id: 6
          },
          errorMsg: {
            type: "string",
            id: 7
          }
        }
      },
      TSProductShareInfoModifyRequest: {
        fields: {
          title: {
            type: "string",
            id: 1
          },
          sendWord: {
            type: "string",
            id: 2
          },
          imgList: {
            rule: "repeated",
            type: "ScImageInfo",
            id: 3
          },
          price: {
            type: "int32",
            id: 4
          },
          tagIds: {
            rule: "repeated",
            type: "string",
            id: 5
          },
          pid: {
            type: "string",
            id: 6
          }
        }
      },
      TSProductShareInfoModifyResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSProductListInPoolRequest: {
        fields: {
          poolId: {
            type: "string",
            id: 1
          },
          pageNum: {
            type: "int32",
            id: 2
          },
          pageSize: {
            type: "int32",
            id: 3
          }
        }
      },
      TSProductListInPoolResponse: {
        fields: {
          itemList: {
            rule: "repeated",
            type: "ProductItem",
            id: 1
          },
          errorCode: {
            type: "int32",
            id: 2
          },
          errorMsg: {
            type: "string",
            id: 3
          },
          isEnd: {
            type: "bool",
            id: 4
          }
        },
        nested: {
          ProductItem: {
            fields: {
              pid: {
                type: "string",
                id: 1
              },
              productName: {
                type: "string",
                id: 2
              },
              price: {
                type: "int32",
                id: 3
              },
              appearanceImgUrl: {
                type: "string",
                id: 4
              }
            }
          }
        }
      },
      TSProductCommentRequest: {
        fields: {
          pid: {
            type: "string",
            id: 1
          },
          content: {
            type: "string",
            id: 2
          }
        }
      },
      TSProductCommentResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSProductCommentListRequest: {
        fields: {
          pid: {
            type: "string",
            id: 1
          },
          pageNum: {
            type: "int32",
            id: 2
          },
          pageSize: {
            type: "int32",
            id: 3
          }
        }
      },
      TSProductCommentListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          commentList: {
            rule: "repeated",
            type: "CommentItem",
            id: 3
          },
          isEnd: {
            type: "bool",
            id: 4
          },
          total: {
            type: "int32",
            id: 5
          }
        },
        nested: {
          CommentItem: {
            fields: {
              avatar: {
                type: "string",
                id: 1
              },
              nickName: {
                type: "string",
                id: 2
              },
              createTime: {
                type: "string",
                id: 3
              },
              content: {
                type: "string",
                id: 4
              }
            }
          }
        }
      },
      TSMyCommentListRequest: {
        fields: {
          pid: {
            type: "string",
            id: 1
          }
        }
      },
      TSMyCommentListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          commentList: {
            rule: "repeated",
            type: "CommentItem",
            id: 3
          }
        },
        nested: {
          CommentItem: {
            fields: {
              avatar: {
                type: "string",
                id: 1
              },
              nickName: {
                type: "string",
                id: 2
              },
              createTime: {
                type: "string",
                id: 3
              },
              content: {
                type: "string",
                id: 4
              }
            }
          }
        }
      },
      ResourceItem: {
        fields: {
          title: {
            type: "string",
            id: 1
          },
          content: {
            type: "string",
            id: 2
          },
          position: {
            type: "int32",
            id: 3
          },
          upOrDown: {
            type: "int32",
            id: 4
          },
          imgList: {
            rule: "repeated",
            type: "BannerItem",
            id: 5
          },
          jumpLink: {
            type: "string",
            id: 6
          },
          jumpType: {
            type: "ExchangeCardResourceStatue",
            id: 7
          }
        }
      },
      TalentItem: {
        fields: {
          avator: {
            type: "string",
            id: 1
          },
          name: {
            type: "string",
            id: 2
          },
          exchange: {
            type: "int32",
            id: 3
          },
          sold: {
            type: "int32",
            id: 4
          },
          feedItem: {
            rule: "repeated",
            type: "FeedItem",
            id: 5
          }
        }
      },
      FeedItem: {
        fields: {
          pid: {
            type: "string",
            id: 1
          },
          imgUrl: {
            type: "string",
            id: 2
          },
          content: {
            type: "string",
            id: 3
          },
          feedType: {
            type: "ExchangeFeedItemStatue",
            id: 4
          },
          price: {
            type: "int32",
            id: 5
          },
          avator: {
            type: "string",
            id: 6
          },
          username: {
            type: "string",
            id: 7
          },
          likeCount: {
            type: "int32",
            id: 8
          },
          isLike: {
            type: "bool",
            id: 9
          },
          NewsName: {
            type: "string",
            id: 10
          },
          officialPrice: {
            type: "int32",
            id: 11
          }
        }
      },
      HotItem: {
        fields: {
          content: {
            type: "string",
            id: 1
          }
        }
      },
      DefaultItem: {
        fields: {
          content: {
            type: "string",
            id: 1
          }
        }
      },
      TSPSExchangeDialogRequest: {
        fields: {}
      },
      TSPSExchangeDialogResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          exchange: {
            type: "bool",
            id: 3
          },
          count: {
            type: "int32",
            id: 4
          },
          mostMatchCount: {
            type: "int32",
            id: 5
          },
          ExchangeList: {
            rule: "repeated",
            type: "ExchangeItem",
            id: 6
          }
        }
      },
      TSPSSearchBoxRequest: {
        fields: {}
      },
      TSPSSearchBoxResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          hotList: {
            rule: "repeated",
            type: "HotItem",
            id: 3
          },
          defaultList: {
            rule: "repeated",
            type: "DefaultItem",
            id: 4
          }
        }
      },
      TSPSAllResourceRequest: {
        fields: {}
      },
      TSPSAllResourseResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          talent: {
            rule: "repeated",
            type: "TalentItem",
            id: 3
          }
        }
      },
      TSPSTalentListRequest: {
        fields: {}
      },
      TSPSTalentListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          talent: {
            rule: "repeated",
            type: "TalentItem",
            id: 3
          }
        }
      },
      TSPSCardResourcesRequest: {
        fields: {}
      },
      TSPSCardResourcesResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          resource: {
            rule: "repeated",
            type: "ResourceItem",
            id: 3
          }
        }
      },
      TSPSLabelListRequest: {
        fields: {
          takeAll: {
            type: "bool",
            id: 1
          }
        }
      },
      TSPSLabelListresponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          labelList: {
            rule: "repeated",
            type: "LabelItem",
            id: 3
          }
        }
      },
      TSPSFeedListRequest: {
        fields: {
          pageNum: {
            type: "int32",
            id: 1
          },
          pageSize: {
            type: "int32",
            id: 2
          },
          labelId: {
            type: "int32",
            id: 3
          },
          searchWord: {
            type: "string",
            id: 4
          }
        }
      },
      TSPSFeedListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          feedList: {
            rule: "repeated",
            type: "FeedItem",
            id: 3
          },
          isEnd: {
            type: "bool",
            id: 4
          }
        }
      },
      TSPSProductLikeRequest: {
        fields: {
          pid: {
            type: "string",
            id: 1
          },
          like: {
            type: "bool",
            id: 2
          }
        }
      },
      TSPSProductLikeResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSProductTagListRequest: {
        fields: {}
      },
      TSGetQrCodeRequest: {
        fields: {
          scene: {
            type: "string",
            id: 1
          }
        }
      },
      TSGetQrCodeResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          qrBase64: {
            type: "string",
            id: 3
          }
        }
      },
      UserInfoItem: {
        fields: {
          avatar: {
            type: "string",
            id: 1
          },
          nickName: {
            type: "string",
            id: 2
          },
          exchangeOutCount: {
            type: "int32",
            id: 3
          },
          publishCount: {
            type: "int32",
            id: 4
          },
          isAttention: {
            type: "bool",
            id: 5
          },
          uid: {
            type: "int32",
            id: 6
          },
          isUidCheck: {
            type: "bool",
            id: 7
          }
        }
      },
      UserProductItems: {
        fields: {
          userInfo: {
            type: "UserInfoItem",
            id: 1
          },
          productItem: {
            rule: "repeated",
            type: "PsProductItem",
            id: 2
          }
        }
      },
      BuyProductItem: {
        fields: {
          productItem: {
            type: "PsProductItem",
            id: 1
          },
          expressFee: {
            type: "int32",
            id: 2
          },
          payAmount: {
            type: "int32",
            id: 3
          },
          transferFee: {
            type: "int32",
            id: 4
          },
          transferFeePercent: {
            type: "int32",
            id: 5
          }
        }
      },
      TSShoppingCartListRequest: {
        fields: {}
      },
      TSShoppingCartListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          itemList: {
            rule: "repeated",
            type: "UserProductItems",
            id: 3
          },
          totalPrice: {
            type: "int32",
            id: 4
          }
        }
      },
      TSShoppingCartCheckRequest: {
        fields: {
          uid: {
            type: "int32",
            id: 1
          },
          pid: {
            type: "string",
            id: 2
          }
        }
      },
      TSShoppingCartCheckResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSShoppingCartAddRequest: {
        fields: {
          pid: {
            type: "string",
            id: 1
          }
        }
      },
      TSShoppingCartAddResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSShoppingCartDelRequest: {
        fields: {
          pid: {
            rule: "repeated",
            type: "string",
            id: 1
          }
        }
      },
      TSShoppingCartDelResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          }
        }
      },
      TSMallBuyerOrdersPageRequest: {
        fields: {
          addrId: {
            type: "string",
            id: 2
          }
        }
      },
      TSMallBuyerOrdersPageResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          itemList: {
            rule: "repeated",
            type: "UserProductItems",
            id: 3
          },
          payTotalAmount: {
            type: "int32",
            id: 4
          }
        }
      },
      NewProductItem: {
        fields: {
          pdtId: {
            type: "string",
            id: 1
          },
          imgUrl: {
            type: "string",
            id: 2
          },
          content: {
            type: "string",
            id: 3
          },
          price: {
            type: "int32",
            id: 4
          },
          avator: {
            type: "string",
            id: 5
          },
          username: {
            type: "string",
            id: 6
          },
          leftNum: {
            type: "int32",
            id: 7
          },
          totalNum: {
            type: "int32",
            id: 8
          },
          pdType: {
            type: "PsProductTypeEnum",
            id: 9
          },
          logoImg: {
            type: "string",
            id: 10
          }
        }
      },
      TSNewProductDeltailRequest: {
        fields: {
          PdtId: {
            type: "string",
            id: 1
          },
          pdType: {
            type: "PsProductTypeEnum",
            id: 2
          }
        }
      },
      TSNewProductDeltailResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          userInfo: {
            type: "UserInfo",
            id: 3
          },
          product: {
            type: "ScProductDTO",
            id: 4
          }
        }
      },
      TsGetStockProductListRequest: {
        fields: {
          pageNum: {
            type: "int32",
            id: 1
          },
          pageSize: {
            type: "int32",
            id: 2
          },
          pageType: {
            type: "PsProductPageTypeEnum",
            id: 3
          }
        }
      },
      TsGetStockProductListResponse: {
        fields: {
          errorCode: {
            type: "int32",
            id: 1
          },
          errorMsg: {
            type: "string",
            id: 2
          },
          productItem: {
            rule: "repeated",
            type: "NewProductItem",
            id: 3
          },
          isEnd: {
            type: "bool",
            id: 4
          }
        }
      }
    }
  }
});

export { $root as default };
